
export const thingsToDoArr = [
    

  
      



]



// start showsArr

export const showsArr = [
      
      
     

      {
        title: "Pride Week 2020",
        desc: "",
        date: "12.06.20",
        img:"Concerts/Pride_Parade_2019.jpg",
        side_img:"Concerts/Pride_Parade_2019.jpg",
        link:"/Posts/index.php?postType=concerts&post=Pride_Week_2020",
        css_class: "unic-singer-Pride_Parade_2020",
        id: "Pride_Week_2020",
        book_now : "READ MORE"
      },
      
      {
        title: "Nick Cave & Bad Seeds",
        desc: "",
        date: "17.06.20",
        img: "Concerts/nickcave-badseeds.jpg",
        side_img: "Concerts/nickcave-badseeds.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=Nickcave-Badseeds",
        id: "Nickcave_Badseeds",
        css_class: "unic-singer-nickcave-badseeds",
        book_now : "READ MORE"
      },
      {
        title: "The Pixies",
        desc: "",
        date: "09.2020",
        img: "Concerts/1.jpg",
        side_img: "Concerts/1.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=The_Pixies_2020",
        css_class: "unic-singer-pixies-2020",
        id: "The_Pixies_2020",
        book_now : "READ MORE"
      },
      {
        title: "Celine Dion",
        desc: "",
        date: "04.08.20",
        img: "Concerts/Celine_Dion.jpg",
        side_img: "Concerts/Celine_Dion.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
        css_class: "unic-singer-Celine_Dion",
        id: "Celine_Dion",
        book_now : "READ MORE"
      },
      {
        title: "DGTL FESTIVAL",
        desc: "",
        date: "08.2020",
        img: "Concerts/dgtl-festival.jpg",
        side_img: "Concerts/dgtl-festival.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
        css_class: "unic-singer-dgtl2020",
        id: "DGTL_Festival_2020",
        book_now : "READ MORE"
      },

      {
        title: "Hutzot Hayotzer Jerusalem",
        desc: "",
        date: "08.2020",
        img: "Concerts/international-arts.jpg",
        side_img: "Concerts/international-arts.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
        css_class: "unic-singer-hutzot_hayotzer",
        id: "Hutzot_Hayotzer_Jerusalem_2020", 
        book_now : "READ MORE"
      },

      {
        title: "Jerusalem Beer Festival",
        desc: "",
        date: "08.2020",
        img: "Concerts/jer-beer-ferstival.jpg",
        side_img: "Concerts/jer-beer-ferstival.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
        css_class: "unic-singer-jbf_2020",
        id: "Jerusalem_Beer_Festival_2020",
        book_now : "READ MORE"
      },

      {
        title: "Jerusalem Wine Festival",
        desc: "",
        date: "08.2020",
        img:"Concerts/wineFestive.jpg",
        side_img:"Concerts/wineFestive.jpg",
        link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
        css_class: "unic-singer-jwf-2020",
        id: "Jerusalem_Wine_Festival_2020",
        book_now : "READ MORE"
      },

      {
        title: "Open Houses Festival",
        desc: "",
        date: "09.2020",
        img: "Concerts/open-houses-festival.jpg",
        side_img: "Concerts/open-houses-festival.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
        css_class: "unic-singer-openhf-2020",
        id: "Open_Houses_Festival_2020",
        book_now : "READ MORE"
      },
      {
        title: "The Jerusalem March",
        desc: "",
        date: "03.09.2020",
        img: "Concerts/jerusalem-march.jpg",
        side_img: "Concerts/jerusalem-march.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
        css_class: "unic-singer-jerusalem-march-2020",
        id: "The_Jerusalem_March_2020",
        book_now : "READ MORE"
      },


      // Double posts for complite the SHOS carousel in mobile
      {
        title: "Celine Dion",
        desc: "",
        date: "04.08.20",
        img: "Concerts/Celine_Dion.jpg",
        side_img: "Concerts/Celine_Dion.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
        css_class: "unic-singer-Celine_Dion",
        id: "Celine_Dion",
        isDouble: true,
        book_now : "READ MORE"
      },
      {
        title: "DGTL FESTIVAL",
        desc: "",
        date: "08.2020",
        img: "Concerts/dgtl-festival.jpg",
        side_img: "Concerts/dgtl-festival.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
        css_class: "unic-singer-dgtl2020",
        id: "DGTL_Festival_2020",
        isDouble: true,
        book_now : "READ MORE"
      },
      // END Double posts for complite the SHOS carousel in mobile

      

      

      

      
       
      

      

      /*----------------OLD SINGERS------------------*/

      {
        title: "Natalia Oreiro",
        desc: "Natalia to Wow Tel Aviv in March",
        date: "20.03.2018",
        img: "Concerts/32.jpg",
        side_img: "Concerts/Sidebar/46.jpg",
        link:  "/Posts/index.php?postType=concerts&post=44",
        css_class: "unic-singer-13",
        id:44,
        book_now: "Read More"
      },


       {
        title: "Backstreet Boys",
        desc: "The Backstreet Boys are Back and Larger Than Life",
        date: "22.04.2018",
        img: "Concerts/51.jpg",
        side_img: "Concerts/Sidebar/53.jpg",
        link:  "/Posts/index.php?postType=concerts&post=51",
        css_class: "unic-singer-20",
        id:51,
        a_star: true,
        book_now: "Read More"
      },
      
      {
       title: "Led Zeppelin 2",
       desc : "Don’t Miss the Zeps in Tel Aviv!" ,
       date : "07-10.01.2018",
       img  : "Concerts/20.jpg",
       side_img  : "Concerts/Sidebar/29.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=29" ,
       css_class: "unic-singer-3",
       id:29,
       book_now : "Read More"
      },

      {
        title: "Chris Rock",
        desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
        date: "08-09.01.2018",
        img: "Concerts/6.jpg",
        side_img: "Concerts/Sidebar/16.jpg",
        link:  "/Posts/index.php?postType=concerts&post=17",
        css_class: "unic-singer-4",
        id:17,
        book_now: "Read More"
      },

      {
       title: "Jerry Seinfeld",
       desc : "Live in Tel Aviv for the first time ever!" ,
       date : "30.12.2017",
       img  : "Concerts/jerry.jpg",
       side_img  : "Concerts/Sidebar/jerry.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=36" ,
       css_class: "unic-singer-2",
       id:36,
       book_now : "Read More"
      },

      {
       title: "Buena Vista",
       desc : "Live in Tel Aviv for the first time ever!" ,
       date : "21-26.12.2017",
       img  : "Concerts/buena.jpg",
       side_img  : "Concerts/Sidebar/buena.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=35" ,
       id:35,
       book_now : "Read More"
      },

     {
       title: "Justin Bieber",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "03.05.2017",
       img  : "Concerts/justin.jpg",
       side_img  : "Concerts/Sidebar/9.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=9" ,
       a_star  : true,
       id:9,
       book_now : "Read More"
      },

      {
       title: "AEROSMITH",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "28.06.2017",
       img  : "Concerts/aerosmith3.jpg",
       side_img  : "Concerts/Sidebar/10.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=10" ,
       a_star  : true,
       id:10,
       book_now : "Read More"
      },

      {
       title: "Britney Spears ",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "03.07.2017",
       img  : "Concerts/britney.jpg",
       side_img  : "Concerts/Sidebar/2.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=2" ,
       a_star  : true,
       id: 2,
       book_now : "Read More"
      },

      {
       title: "Guns N' Roses",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "15.07.2017",
       img  : "Concerts/Guns-N-roses.jpg",
       side_img  : "Concerts/Sidebar/4.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=4" ,
       a_star  : true,
       id:4,
       book_now : "Read More"
      },

      {
       title: "Bryan Adams ",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "04-06.12.2017",
       img  : "Concerts/7.jpg",
       side_img  : "Concerts/Sidebar/15.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=16" ,
       a_star  : true,
       id:16,
       book_now : "Read More"
      },

      {
       title: "NICK CAVE ",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "19.11.2017",
       img  : "Concerts/4.jpg",
       side_img  : "Concerts/Sidebar/8.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=8" ,
       id:8,
       book_now : "Read More"
      },

      {
        title: "RADIOHEAD ",
        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
        date : "19.07.2017",
        img  : "Concerts/360x539.jpg",
        side_img  : "Concerts/Sidebar/5.jpg" ,
        link :  "/Posts/index.php?postType=concerts&post=5" ,
        a_star  : true,
        id:5,
        book_now : "Read More"
      },

      {
       title: "The Chainsmokers",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "3.08.2017",
       img  : "Concerts/9.jpg",
       side_img  : "Concerts/Sidebar/14.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=13" ,
       id:13,
       book_now : "Read More"
      },

      {
       title: "Blue Man Group",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "7-23.08.2017",
       img  : "Concerts/14.jpg",
       side_img  : "Concerts/Sidebar/22.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=19" ,
       id:19,
       book_now : "Read More"
      },

      {
       title: "Regina Spektor",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "19.08.2017",
       img  : "Concerts/2.jpg",
       side_img  : "Concerts/Sidebar/7.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=7" ,
       id:7,
       book_now : "Read More"
      },

      {
       title: "Sean Paul",
       desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
       date : "22.08.2017",
       img  : "Concerts/13.jpg",
       side_img  : "Concerts/Sidebar/21.jpg" ,
       link :  "/Posts/index.php?postType=concerts&post=20" ,
      id:20,
       a_star  : true,
       book_now : "Read More"
      },

      {
        title: "Pride Parade 2019",
        desc: "",
        date: "14.06.2019",
        img:"Concerts/Pride_Parade_2019.jpg",
        side_img:"Concerts/Pride_Parade_2019.jpg",
        link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
        css_class: "unic-singer-Pride_Parade_2019",
        id: "Pride_Parade_2019",
        book_now : "READ MORE"
      },

      {
        title: "Daddy Yankee",
        desc: "",
        date: "26.06.2019",
        img: "Concerts/daddyyanke.jpg",
        side_img: "Concerts/bon-j.jpg",
        link: "/Posts/index.php?postType=concerts&post=76",
        css_class: "unic-singer-daddyyanke",
        book_now : "READ MORE"
      },

      {
        title: "Tom Jones",
        desc: "",
        date: "03.07.2019",
        img: "Concerts/tomjones.jpg",
        side_img: "Concerts/bon-j.jpg",
        link: "/Posts/index.php?postType=concerts&post=76",
        css_class: "unic-singer-tomjones",
        book_now : "READ MORE"
      },

      {
        title: "Paul Anka",
        desc: "",
        date: "11.07.2019",
        img: "Concerts/paul.jpg",
        side_img: "Concerts/bon-j.jpg",
        link: "/Posts/index.php?postType=concerts&post=76",
        css_class: "unic-singer-paul",
        book_now : "READ MORE"
      },

      {
        title: "Sean Paul",
        desc: "",
        date: "13.07.2019",
        img: "Concerts/seanpaul.jpg",
        side_img: "Concerts/bon-j.jpg",
        link: "/Posts/index.php?postType=concerts&post=76",
        css_class: "unic-singer-seanpaul",
        book_now : "READ MORE"
      },

      {
        title: "Ozuna",
        desc: "",
        date: "24.07.2019",
        img: "Concerts/ozuna.jpg",
        side_img: "Concerts/bon-j.jpg",
        link: "/Posts/index.php?postType=concerts&post=76",
        css_class: "unic-singer-ozuna",
        book_now : "READ MORE"
      },

      {
        title: "Jerusalem Film Festival",
        desc: "36 Years of Cinema Magic!",
        date: "04.08.2019",
        img:"Concerts/filmFestive.jpg",
        side_img:"Concerts/filmFestive.jpg",
        link: "/Posts/index.php?postType=concerts&post=68",
        css_class: "unic-singer-68",
        id:68,
        book_now : "READ MORE"
      },

      {
        title: "Bon Jovi",
        desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
        date: "25.07.2019",
        img: "Concerts/bon-j.jpg",
        side_img: "Concerts/bon-j.jpg",
        link: "/Posts/index.php?postType=concerts&post=76",
        css_class: "unic-singer-76",
        id: 76,
        book_now : "READ MORE"
      },

      {
        title: "J Balvin",
        desc: "",
        date: "30.07.2019",
        img: "Concerts/balvin.jpg",
        side_img: "Concerts/bon-j.jpg",
        link: "/Posts/index.php?postType=concerts&post=76",
        css_class: "unic-singer-balvin",
        book_now : "READ MORE"
      },

      {
        title: "Jerusalem Wine Festival",
        desc: "Wine and dine in the holy city!",
        date: "30.07.2019",
        img:"Concerts/wineFestive.jpg",
        side_img:"Concerts/wineFestive.jpg",
        link: "/Posts/index.php?postType=concerts&post=69",
        css_class: "unic-singer-69",
        id:69,
        book_now : "READ MORE"
      },

      {
        title: "J.Lo",
        desc: "",
        date: "01.08.2019",
        img:"Concerts/jlo.jpg",
        side_img:"Concerts/jlo.jpg",
        link:"/Posts/index.php?postType=concerts&post=jlo",
        css_class: "unic-singer-jlo",
        id: "J_Lo",
        book_now : "READ MORE"
      },

      {
        title: "The International Arts",
        desc: "",
        date: "12-24.08.2019",
        img: "Concerts/international-arts.jpg",
        side_img: "Concerts/international-arts.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=94",
        css_class: "unic-singer-inter-arts",
        id: "The_International_Arts", 
        book_now : "READ MORE"
      },

      {
        title: "Jerusalem Beer Festival",
        desc: "",
        date: "28-29.08.2019",
        img: "Concerts/jer-beer-ferstival.jpg",
        side_img: "Concerts/jer-beer-ferstival.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=91",
        css_class: "unic-singer-jbf",
        id: "Jerusalem_Beer_Festival",
        book_now : "READ MORE"
      },

      {
        title: "Lionel Richie",
        desc: "",
        date: "12.09.2019",
        img:"Concerts/lionel-richie.jpg",
        side_img:"Concerts/lionel-richie.jpg",
        link:"/Posts/index.php?postType=concerts&post=lionelrichie",
        css_class: "unic-singer-lionel-richie",
        book_now : "READ MORE"
      },

      {
        title: "Open Houses Festival",
        desc: "",
        date: "19-21.09.2019",
        img: "Concerts/open-houses-festival.jpg",
        side_img: "Concerts/open-houses-festival.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=96",
        css_class: "unic-singer-openhf",
        id: "Open_Houses_Festival",
        book_now : "READ MORE"
      },

      

      {
        title: "Open Restaurants TLV",
        desc: " Feed Your Curiosity!",
        date: "2019",
        img: "Concerts/71.jpg",
        side_img: "Concerts/72.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=70",
        css_class: "unic-singer-70",
        book_now : "READ MORE"
      },
       {
        title: "DGTL FESTIVAL",
        desc: "",
        date: "14.10.2019",
        img: "Concerts/dgtl-festival.jpg",
        side_img: "Concerts/dgtl-festival.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=93",
        css_class: "unic-singer-dgtl2019",
        id: "DGTL_Festival",
        book_now : "READ MORE"
      },
      {
        title: "Cycle Tel Aviv",
        desc: "",
        date: "18.10.2019",
        img: "Concerts/cycle-tlv-2019.jpg",
        side_img: "Concerts/cycle-tlv-2019.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=93",
        css_class: "unic-singer-cycle-tlv-2019",
        id: "Cycle_Tel_Aviv",
        book_now : "READ MORE"
      },
      {
        title: "Night Run Tel Aviv",
        desc: "",
        date: "30.10.2019",
        img: "Concerts/night-run-tlv.jpg",
        side_img: "Concerts/night-run-tlv.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=98",
        css_class: "unic-singer-tlv-nightrun2019",
        id: "Night_Run_TelAviv",
        book_now : "READ MORE"
      },

      {
        title: "Culinary Festival",
        desc: "Special Edition: Female Chefs",
        date: "09-23.11.2019",
        img: "Concerts/72.jpg",
        side_img: "Concerts/73.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=71",
        css_class: "unic-singer-71",
        book_now : "READ MORE"
      },
      
     {
        title: "Open Restaurants Jerusalem",
        desc: "",
        date: "19-23.11.2019",
        img:"Concerts/Open_Restaurants_Jerusalem.jpg",
        side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
        link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
        css_class: "unic-singer-Open_Restaurants_Jerusalem",
        id: "Open_Restaurants_Jerusalem",
        book_now : "READ MORE"
      },
      {
        title: "Louis CK",
        desc: "",
        date: "23.11.2019",
        img: "Concerts/Louis_CK.jpg",
        side_img: "Concerts/Louis_CK.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=Louis_CK",
        css_class: "unic-singer-Louis_CK",
        id: "Louis_CK",
        book_now : "READ MORE"
      },
      {
        title: "Jim Jeffries",
        desc: "",
        date: "21.12.2019",
        img:"Concerts/jim-jeffries.jpg",
        side_img:"Concerts/jim-jeffries.jpg",
        link:"/Posts/index.php?postType=concerts&post=jimjeffries",
        css_class: "unic-singer-jim-jeffries",
        book_now : "READ MORE"
      },

      {
        title: "Open Restaurants TLV",
        desc: " Feed Your Curiosity!",
        date: "2019",
        img:"Concerts/openRestTlv.jpg",
        side_img:"Concerts/openRestTlv.jpg",
        link: "/Posts/index.php?postType=concerts&post=70",
        css_class: "unic-singer-70",
        id:70,
        book_now : "READ MORE"
      },
      {
        title: "Tel Aviv Marathon",
        desc: "",
        date: "28.02.20",
        img: "Concerts/tlv-marathon.jpg",
        side_img: "Concerts/tlv-marathon.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=97",
        css_class: "unic-singer-tlv-marathon2020",
        id: "TelAviv_Marathon",
        book_now : "READ MORE"
      },
      {
        title: "Purim 2020",
        desc: "",
        date: "09-10.03.20",
        img: "Concerts/purim2019.jpg",
        side_img: "Concerts/purim2019.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=Purim_2020",
        css_class: "unic-purim2020",
        id: "Purim_2020",
        book_now : "READ MORE"
      },

      {
        title: "Tel Aviv Fashion Week",
        desc: "",
        date: "03.2020",
        img: "Concerts/fationWeek.jpg",
        side_img: "Concerts/fationWeek.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week_2020",
        css_class: "unic-fashion-week-2020",
        id: "TelAviv_Fashion_Week_2020",
        book_now : "READ MORE"
      },
      {
        title: "Jerusalem Marathon",
        desc: "",
        date: "20.03.20",
        img: "Concerts/jer-marathon.jpg",
        side_img: "Concerts/jer-marathon.jpg",
        link: this.url + "/Posts/index.php?postType=concerts&post=95",
        css_class: "unic-singer-jer-marathon2019",
        id: "Jerusalem_Marathon",
        book_now : "READ MORE"
      },
      // {
      //   title: "The Rubinstein International Competition ",
      //   desc: "",
      //   date: "05-21.05.2020",
      //   img:"Concerts/piano-competition-2020.jpg",
      //   side_img:"Concerts/piano-competition-2020.jpg",
      //   link:"/Posts/index.php?postType=concerts&post=Piano_Competition_2020",
      //   css_class: "unic-singer-piano-competition-2020",
      //   id: "Piano_Competition_2020",
      //   book_now : "READ MORE"
      // },
      // {
      //   title: "Red Hot Chili Peppers",
      //   desc: "",
      //   date: "10.06.20",
      //   img:"Concerts/red-hot-chili-peppers-2020.jpg",
      //   side_img:"Concerts/red-hot-chili-peppers-2020.jpg",
      //   link:"/Posts/index.php?postType=concerts&post=Red_Hot_Chili_Peppers_2020",
      //   css_class: "unic-singer-red-hot-chili-peppers-2020",
      //   id: "Red_Hot_Chili_Peppers_2020",
      //   book_now : "READ MORE"
      // },
      // {
      //   title: "White Night",
      //   desc: "",
      //   date: "06.2020",
      //   img:"Concerts/53.jpg",
      //   side_img:"Concerts/53.jpg",
      //   link:"/Posts/index.php?postType=concerts&post=White_Night_2020",
      //   css_class: "unic-singer-white-night-2020",
      //   id: "White_Night_2020",
      //   book_now : "READ MORE"
      // },

];

// End showsArr




export const faqData  = [ 
   {  
      id : 1 ,
      q : "أسئلة شائعة بخصوص فيروس كوفيد-19",
      answer : `
      <ol start="1">
        <li><strong>أنا سائح أتواجد في إسرائيل  وأنا قلق. من احتمال إصابتي بفيروس كورونا، إلى أين  عليّ أن اتوجّه؟</strong><br/>
           <ul>
               <li>
                  إن كانت درجة حرارتكم تفوق الـ 38 درجة مئوية (100.4 فهرنهايت)، أو كنتم تسعلون، وتواجهون مصاعب في التنفس، أو ظهرت لديكم  أية أعراض تنفّسية أخرى،  فإن عليكم أن تقوموا  فورا  بحجر أنفسكم ذاتيا، والاتصال قسم الإسعاف على الرقم 101 من أجل الحصول على المشورة الطبية. لا تذهبوا إلى العيادة أو قسم الطوارئ.
               </li>
           </ul>
        </li>
        <li><strong>متى ستفتح إسرائيل أبوابها للزوار مجددا؟</strong><br/>
           <ul>
               <li>
                 في هذه اللحظة ليس هنالك تاريخ معروف لعودة إسرائيل لاستقبال الزوار القادمين إليها
               </li>
           </ul>
        </li>
       
       
      </ol>
      `,
      isOpen : false
   },
   {  
      id : 2 ,
      q : "هل القدس وتل أبيب بعيدتان كثيرا؟ ",
      answer : `
      <p>
       بالعكس! إنهما أقرب مما قد تتصوروا، تستغرق سفرة سريعة بالطائرة ما بين 4 -5 ساعات، وبعدها سيكون بإمكانكم الاستمتاع بشواطئ تل أبيب المشمسة،  والمعالم الرائعة في القدس. أفضل ما في الأمر هو أن تل أبيب والقدس تبعدان عن بعضهما مسافة ساعة واحدة بالسيارة.
      </p>
      `,
      isOpen : false
   },

   {  
      id : 3 ,
      q : "كيف يمكنني التجوال في القدس وتل أبيب؟",
      answer : `
      
      <p>
       الباصات وسيارات الأجرة وخطوط سكة الحديد الوطنية هي وسائل النقل الأكثر شعبية ملائمة. توجد في القدس أيضا خدمة سكة حديد خفيفة مريحة توصلكم إلى المواقع الأكثر شهرة في أرجاء المدينة.
      </p>
      <p>
       للاطلاع على معلومات بشأن محطات القطارات، ومساراتها، وجداول تسييرها، ادخلوا إلى الموقع <a target="_blank" href="//www.rail.co.il"><span class="ac-en-font">www.rail.co.il</span></a>
      </p>
      <p>
       للاطلاع على معلومات بشأن مسارات الباصات وجداولها الزمنية بإمكانكم زيارة الموقع <a target="_blank" href="//www.bus.gov.il"><span class="ac-en-font">www.bus.gov.il</span></a>  
      </p>
      <p>
       خط المساعدة بشأن المواصلات العامة <a href="tel:*8787">*8787</a>  
      </p>
      <p>
       تطبيق هاتفي خاص بالمواصلات العامة المحلية <span class="ac-en-font">Moovit</span>
      </p>
      <h4>
      سيارات الأجرة
      </h4>
      <p>
        يمكن الإشارة لسيارات الأجرة المخصصة للسفر داخل المدن وما بينها في الشارع، للتوقّف أو يمكنكم حجزها عبر الهاتف والتطبيقات المتخصصة كتطبيق <span class="ac-en-font">Gett (Get Taxi)</span>>
      </p>

      <h4>
      سيارات الخدمة (شيروت)
      </h4>
      <p>
        تتسع سيارات الخدمة (شيروت)  لـ10 -12 مقعدا، وهي عادة ما تسير على المسارات الرئيسية المخصصة للباصات، داخل المدن وما بينها. من ناحية الأسعار،  فإن تسعيرة استخدام المواصلات لها أسعار محددة مسبقا، كما هو حال الباصات.
      </p>

      <h4>
      استئجار السيارات
      </h4>
      <p>
        يمكن العثور على غالبية مكاتب تأجير السيارات في وسط تل أبيب على امتداد شارع "هيركون"، قريبا من الواجهة البحرية لتل أبيب وفي باقي المناطق، توجد هذه المكاتب في المناطق المحيطة بالفنادق.
      </p>

      <h4>
      <span class="ac-en-font">Tel-O-Fun </span>
      </h4>
      <p>
        خدمة <span class="ac-en-font">Tel-O-Fun</span> هي خدمة لمشاركة الدراجات الهوائية، مقدمة من بلدية تل أبيب، وهي متوفرة للسكان وللسياح معا
        لدى خدمة <span class="ac-en-font">Tel-O-Fun</span> أسطول مكون من 2000 دراجة هوائية موزعة على 200 محطة، وتتيح الخدمة استئجار دراجة وقيادتها على امتداد مسارات الدراجات الهوائية المخصصة لذلك، التي تمتد لمسافة 130 كيلومترا
        بإمكانكم شراء بطاقة تعاقد استئجار يومي أو أسبوعي بواسطة بطاقتك الائتمانية، في أي من محطات التأجير 

      </p>
      .
      `,
      isOpen : false,
   },
   

   {  
      id : 4 ,
      q : "ماذا عن النقود؟",
      answer : `
      <p>
        العملة الإسرائيلية هي الشيكل. يمكن سحب النقود من خلال الصرّافات الآلية في البنوك في أرجاء المدينة.
        تتوفر أيضا صرّافات آلية خاصة في المتاجر المحلية وهي تجبي عمولة تتراوح ما بين 5.90 شيكل إلى 7.90 شيكل مقابل كل عملية سحب نقدي
        خدمات تصريف العملات متوفرة في مكاتب الصرافة من دون عمولات، في المناطق السياحية، وهي عادة ما تكون مفتوحة حتى وقت متأخر.
        بالطبع، فإن بطاقات الاعتماد مقبولة بشكل واسع. كما أن خدمة "ويسترن يونيون" تعمل من خلال مكاتب البريد، وهي توفّر خدمة تحويل الأموال.
      </p>
      `,
      isOpen : false,
   },
   

   {  
      id : 5 ,
      q : "البقاء على اتصال",
      answer : `

        <h4>
          خدمات الهاتف
        </h4>
        <p>
          إن رغبتم، فإن بإمكانكم شراء بطاقة <span class="ac-en-font">SIM</span> ذكية من متاجر الهواتف أو مراكز تقديم المعلومات المحلية، واستخدام بطاقات الدفع المسبق التي تنشر في الكثير من المتاجر، ومكاتب تصريف العملات
        </p>

        <h4>
          نقاط الـ <span class="ac-en-font">Hotspot</span> - الانترنت اللاسلكي المجاني
        </h4>
        <p>
          تفخر تل أبيب بكونها مدينة ذكية حتى أقصى حد. تتوفر تغطية <span class="ac-en-font">WIFI</span> لراحتكم في 80 موقعا مختلفا جول المدينة (بما فيها الشاطئ، مراكز التسلية، وغالبية المناطق السياحية)
        </p>
        <p>
          في القدس، يمكن العثور على مناطق الـ <span class="ac-en-font">WIFI</span> في محطات القطار، الجامعات، المتاحف، مراكز الزوار، قاعات المؤتمرات، المواقع السياحية، والمجمعات التجارية، إلى جانب المركز المحلي لتقديم المعلومات للسيّاح
        </p>

      `,
      isOpen : false,
   },
   

   {  
      id : 6 ,
      q : "عن حالة الطقس",
      answer : `
        <p>
        الطقس في تل أبيب دافئ ولطيف في معظم أيام السنة، أيام الصيف طويلة ومن المناسب قضاؤها على الشاطئ وفي التجوال في المدينة، بينما فصول الشتاء ودودة ومن دون مطر غزير. معدّل  الحرارة العامّ في الشتاء يتراوح ما بين 1-17 درجة مئوية، بينما يتراوح معدلها في الصيف ما بين 24-30 درجة مئوية.

        </p>
        <p>
          تتمتع القدس بمواسم صيف طويلة (تمتد ما بين أيار- مايو وحتى أيلول- سبتمبر) أما فصول الشتاء (التي تمتد ما بين تشرين ثاني - نوفمبر وحتى آذار - مارس) فيمكنها أن تكون شديدة البرودة، وغزيرة المطر، مع احتمالات تساقط الثلج أحيانا، كما تنخفض درجة الحرارة إلى درجة التجمد في بعض الأحيان. للاطلاع على معلومات محدّثة بإمكانك زيارة موقع الأرصاد الجوية الإسرائيلية على العنوان: <a target="_blank" href="//ims.gov.il/ar">www.ims.gov.il</a>

        </p>
      `,
      isOpen : false,
   },

   {  
      id : 7 ,
      q : "هل تختلف ساعات وأيام الدوام؟",
      answer : `
        
        <p>
           نعم، فأيام الدوام الأسبوعية تمتد من الأحد حتى أيام الخميس، في حين أن عطلة نهاية الأسبوع هي يومي الجمعة والسبت. غالبية الأماكن التجارية تكون مفتوحة أيام الجمعة حتى بداية العصر، قبل دخول السبت اليهودي، والذي يبدأ منذ غروب شمس الجمعة وحتى ما بعد غروب شمس السبت بقليل. <a target="_blank" href="//www.timeanddate.com/worldclock/Israel">www.timeanddate.com/worldclock/Israel</a>
        </p>
      `,
      isOpen : false,
   },
   
]


// These posts not for THINGS TO DO Page
export const newPosts = [

    // NEW for EU
    
    {
       "title": "القدس",
        "sml_desc" : "",
         "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jerusalem",
        "isVid": true,
        "vidId": "FvAWuLQEOJw",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": false,
        "ctg": "jerusalem",
        "id": "Jerusalem"
    },
    {
       "title": "الرملة",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/General/ramle-ar.jpg",
        "side_img": "/PostCarousel/General/ramle-ar.jpg",
        "read_more": "READ MORE",
        "css_class":"unic-post-ramlear",
        "isVid": false,
        "isDouble": false,
        "forVidPage": false,
        "ctg": "general",
        "id": "Ramle_ar"
    },
    {
       "title": "مقام النبي موسى",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/General/nabimusa-ar.jpg",
        "side_img": "/PostCarousel/General/nabimusa-ar.jpg",
        "read_more": "READ MORE",
        "css_class":"unic-post-nabimusaar",
        "isVid": false,
        "isDouble": false,
        "forVidPage": false,
        // "ctg": "general",
        // "ctg": "jerusalem",
        "ctg": "deadsea",
        "id": "Nabimusa_ar"
    },

    {
       "title": " كنيسة القيامة ",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/haramalsharifar.jpg",
        "side_img": "/PostCarousel/Jerusalem/haramalsharifar.jpg",
        "read_more": "READ MORE",
        "css_class":"unic-post-haramalsharifar",
        "isVid": false,
        "isDouble": false,
        "forVidPage": false,
        "ctg": "jerusalem",
        "id": "Haram_Al_Sharif_ar"
    },
    {
         "title":"قبر النبي صموئيل",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/nabisamuelar.jpg",
         "side_img":"/PostCarousel/nabisamuelar.jpg",
         "read_more":"READ MORE",
         "css_class":"unic-post-nabisamuelar",
         "isVid" : false,
         "isDouble": false,
         // "ctg"   : 'eilat-negev',
         "ctg"   : 'jerusalem',
          "id"    : 'Nabi_Samuel_ar'
    },
    
    {
       "title": "مساجد يافا",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/TelAviv/mosquesofjaffa-ar.jpg",
        "side_img": "/PostCarousel/TelAviv/mosquesofjaffa-ar.jpg",
        "read_more": "READ MORE",
        "css_class":"unic-post-mosquesOfJaffaar",
        "isVid": false,
        "isDouble": false,
        "forVidPage": false,
        "ctg": "telaviv",
        "id": "MosquesOfJaffa_ar"
    },
    {
        "title": "مدينتان رائعتان",
        // "sml_desc": "One magical unforgettable getaway to the sun",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/General/tw-awesome-cities.jpg",
        "side_img": "/PostCarousel/General/tw-awesome-cities.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=42",
        "isVid": false,
        // "vidId": "b0QexDxEklA",
        "forVidPage": false,
        "isDouble": false,
        "ctg": "general",
        "id": "2_AWESOME_CITIES"
    },
    
    {
       "title": "جبل الزيتون",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/mountofolives.jpg",
        "side_img": "/PostCarousel/Jerusalem/mountofolives.jpg",
        "read_more": "READ MORE",
        "css_class":"unic-post-mountofolivesar",
        "isVid": false,
        "isDouble": false,
        "forVidPage": false,
        "ctg": "jerusalem",
        "id": "Mount_Of_Olives_ar"
    },

    {
       "title": "الكنيست",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/kneset-ar.jpg",
        "side_img": "/PostCarousel/Jerusalem/kneset-ar.jpg",
        "read_more": "READ MORE",
        "css_class":"unic-post-knesetar",
        "isVid": false,
        "isDouble": false,
        "forVidPage": false,
        "ctg": "jerusalem",
        "id": "Kneset_ar"
    },
    
    {
        "title": "سياحة الهايتك",
        // "sml_desc": "Tech Tourism",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/General/techtourism.jpg",
        "side_img": "/PostCarousel/General/techtourism.jpg",
        "read_more": "READ MORE",
        "isVid": false,
        "forVidPage": false,
        "isDouble": false,
        "ctg": "general",
        "id": "Tech_tourism"
    },


    {
       "title": "عسقلان ومزار الحسين بن علي",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/General/ashqelonar.jpg",
        "side_img": "/PostCarousel/General/ashqelonar.jpg",
        "read_more": "READ MORE",
        "isVid": false,
        "isDouble": false,
        "forVidPage": false,
        "ctg": "general",
        "id": "Ashqelon_ar"
    },
    {
       "title": "مسجد الجزار الساحر في مدينة عكا",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/General/aljazzarmosque.jpg",
        "side_img": "/PostCarousel/General/aljazzarmosque.jpg",
        "read_more": "READ MORE",
        "isVid": false,
        "isDouble": false,
        "forVidPage": false,
        "ctg": "general",
        "id": "Al_Jazzar_Mosque_ar"
    },
    {
       "title": "متع الميناء",
        // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports",
        "sml_desc" : "",
        // "desc": "Tel Aviv’s fascinating cultural scene",
         "desc" : "",
        "img": "/PostCarousel/TelAviv/jaffa-port.jpg",
        "side_img": "/PostCarousel/TelAviv/jaffa-port.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Port_Pleasures",
        "isVid": false,
        "isDouble": false,
        "ctg": "telaviv",
        "id": "Port_Pleasures"
    },
    {
       "title": " كنيسة القيامة ",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/churchoftheholysepulcher.jpg",
        "side_img": "/PostCarousel/Jerusalem/churchoftheholysepulcher.jpg",
        "read_more": "READ MORE",
        "css_class":"unic-post-churchoftheholysepulcherar",
        "isVid": false,
        "isDouble": false,
        "forVidPage": false,
        "ctg": "jerusalem",
        "id": "Church_of_the_Holy_Sepulcher_ar"
    },
      
    

    {
       "title": "ظاهرة طبيعية",
        // "sml_desc": "THE DEAD SEA",
         "sml_desc": "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
        "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Natural_Phenomena",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": false,
        "ctg": "deadsea",
        "id": "Natural_Phenomena"
    },
    
    {
        "title": "قهوة في تل أبيب",
        // "sml_desc": "Tel Aviv over a fresh coffee",
        "sml_desc": "",
        // "desc": "Coffee shop culture is fundamental",
        "desc":" ",
        "img": "Videos/coffee.jpg",
         "img_mob":"/Videos/video_mob/coffee.jpg",
        "side_img": "Videos/sidebar/coffee.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=16",
        "vidId": "rVr0gqFC364",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "isDouble": false,
        "id": "Coffee_In_TelAviv"
    },
    {
       "title": "متسادا",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/masada.jpg",
        "side_img": "/PostCarousel/DeadSea/masada.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Masada",
        "isVid": true,
        "vidId": "XxWa_MNm5x8",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": false,
        "ctg": "deadsea",
        "id": "Masada"
    },
    {
         "title":"عكا",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/acre.jpg",
         "side_img":"/PostCarousel/acre.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Acre", 
         "css_class":"unic-post-acre",
         "isVid" : true,
         "isDouble": false,
         "vidId":"KlXXyToCmCM",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'general',
          "id"    : 'Acre'
       },

    {
        "title": "ضيافة فاخرة",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
        "side_img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Boutique_Hospitality",
        "isVid": false,
        "ctg": "telaviv",
        "isDouble": false,
        "id": "Boutique_Hospitality"
    },
    
    {
       "title": "المنتجع الصحي الطبيعي: البحر الميت",
        "sml_desc" : "",
        // "sml_desc": "THE DEAD SEA",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/natural-spa.jpg",
        "side_img": "/PostCarousel/DeadSea/natural-spa.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Natural_Spa",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": false,
        "ctg": "deadsea",
        "id": "Natural_Spa"
    },
    {
         "title":"الجليل",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilee.jpg",
         "side_img":"/PostCarousel/galilee.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Galilee", 
         "css_class":"unic-post-galilee",
         "isVid" : true,
         "isDouble": false,
         "vidId":"5Ep3GgxELag",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Galilee'
    },
    

     {
         "title":"مرصد الطيور في بحيرة الحولة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "side_img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Birdtastic_Hula_Lake", 
         "css_class":"unic-post-birdtastic-hula-lake",
         "isVid" : true,
         "vidId":"ImobrsxsKl8",
         // "isVid": false,
         "forVidPage": true,
         "isDouble": false,
         "ctg"   : 'north',
          "id"    : 'Birdtastic_Hula_Lake'
    },

    {
         "title":"بيسان",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/bet-shean.jpg",
         "side_img":"/PostCarousel/bet-shean.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Bet_Shean", 
         "css_class":"unic-post-bet-shean",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'north',
          "id"    : 'Bet_Shean'
    },
    {
       "title" : "ثقافة بلا توقف",
        // "sml_desc": "Non Stop Culture",
        "sml_desc" : "",
        // "desc": "Tel Aviv’s fascinating cultural scene",
         "desc" : "",
        "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Non_Stop_Culture",
        "isVid": false,
        // "vidId":"MXtcTm_JXus",
        "ctg": "telaviv",
        "forVidPage": false,
        "isDouble": false,
        "id": "Non_Stop_Culture"
    },

    

    {
         "title":"قيسارية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/caesarea.jpg",
         "side_img":"/PostCarousel/caesarea.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Caesarea", 
         "css_class":"unic-post-caesarea",
         "isVid" : true,
         "isDouble": false,
         "vidId":"eLZ433_S6HI",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Caesarea'
    },

    {
         "title":"روش بينا",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/rosh-pina.jpg",
         "side_img":"/PostCarousel/rosh-pina.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Rosh_Pina", 
         "css_class":"unic-post-rosh-pina",
         "isVid" : true,
         "isDouble": false,
         "vidId":"_qKbHL5-qrQ",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Rosh_Pina'
    },
    {
        "title": "تل أبيب بجانب البحر",
        // "sml_desc": "Cause life’s a beach in Tel Aviv ",
        "sml_desc": "",
        // "desc": "Get ready for some serious fun",
        "desc": "",
        "img": "Videos/a.jpg",
        "img_mob":"/Videos/video_mob/a.jpg",
        "side_img": "Videos/sidebar/a.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=3",
        "css_class": "unic_video-post-4",
        // "vidId": "XDei1Zy_cu4",
        "ctg": "telaviv",
        "isVid": false,
        "isDouble": false,
        "id": "TelAviv_By_The_Sea"
    },
    {
        "title": "أسواق بلا توقّف",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
        "side_img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Non_Stop_Markets",
        "isVid": false,
        "ctg": "telaviv",
        "isDouble": false,
        "id": "Non_Stop_Markets"
    },
    // Hadar asked to hide the video inside this post on 2021-02-04
    {
        "title": "أمور يجب عليكم تجربتها في القدس",
        // "sml_desc": "5 things to do in the stunning city",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/18.jpg",
        "side_img": "/PostCarousel/18.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jerusalem_Musts",
        "isVid": false,
        "isDouble": false,
        // "vidId": "FvAWuLQEOJw",
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Jerusalem_Musts"
    },
    // End Hadar asked to hide the video inside this post on 2021-02-04
    {
         "title":"تجربة الكيبوتس التي لا تضاهى",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/kibbutz-experience.jpg",
         "side_img":"/PostCarousel/kibbutz-experience.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Kibbutz_Experience", 
         "css_class":"unic-post-kibbutz-experience",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'north',
          "id"    : 'The_Kibbutz_Experience'
    },
    {
         "title":"حدائق البهائيين المذهلة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/bahai-gardens.jpg",
         "side_img":"/PostCarousel/bahai-gardens.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Bahai_Gardens", 
         "css_class":"unic-post-bahai-gardens",
         "isVid" : true,
         "isDouble": false,
         "vidId":"JV_AmfRULOo",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'The_Bahai_Gardens'
    },

    
    {
        "title": "عجائب حائط المبكى",
        "sml_desc": "",
        "img": "thingsToDo/4.jpg",
        "side_img": "thingsToDo/sidebar/4.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Western_Wall_Wonders",
        "css_class": "unic_video-post-Western_Wall_Wonders",
        "vidId": "88OV6xU0vPI",
        "isVid": false,
        "isDouble": false,
        "id": "Western_Wall_Wonders",
        "ctg": "jerusalem",
        "showOnHome": false,

    },
    {
        "title": "روعة المدينة البيضاء",
        "sml_desc": "",
        "desc": "",
        "img": "thingsToDo/6.jpg",
        "side_img": "thingsToDo/sidebar/6.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=20",
        "css_class": "unic_video-post-1",
        "vidId": "88OV6xU0vPI",
        "isVid": false,
        "isDouble": false,
        // "isVid": false,
        "id": "White_City_Splendor",
        "showOnHome": false,
        "ctg": "telaviv"

    },
    {
         "title":"طبريا",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/tiberias.jpg",
         "side_img":"/PostCarousel/tiberias.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Tiberias", 
         "css_class":"unic-post-tiberias",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'north',
          "id"    : 'Tiberias'
    },
    {
       "title": "جادة مأمن الله",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "side_img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Mamilla_Avenue",
        "isVid": true,
        "vidId": "V0Acsw3Hf_M",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": false,
        "ctg": "jerusalem",
        "id": "Mamilla_Avenue"
    },

     {
        "title": "البحر الميت",
        // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/DeadSea/next-level-ar.jpg",
        "side_img": "/PostCarousel/DeadSea/next-level-ar.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Next_Level_DS",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": false,
        "ctg": "deadsea",
        "id": "Next_Level_DS"
    },
    {
        "title": "سحر الميناء",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/TelAviv/portcharms.jpg",
        "side_img": "PostCarousel/TelAviv/portcharms.jpg",
        "read_more": "READ MORE",
        "vidId": "",
        "ctg": "telaviv",
        "isDouble": false,
        "isVid": false,
        "id": "Port_Charms"
    },
    {
         "title":"مسار الرحلات الوطني في إسرائيل",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-israel-national-trail.jpg",
         "side_img":"/PostCarousel/the-israel-national-trail.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Israel_National_Trail", 
         "css_class":"unic-post-the-israel-national-trail",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'The_Israel_National_Trail'
    },
    

    


    {
       "title": "سحر البحر الميت",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/magical-deadsea.jpg",
        "side_img": "/PostCarousel/DeadSea/magical-deadsea.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Magical_Deadsea",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": false,
        "ctg": "deadsea",
        "id": "Magical_Deadsea"
    },
    {
       "title": "بوابات القدس",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/gates.jpg",
        "side_img": "/PostCarousel/Jerusalem/gates.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=The_Gates_Of_Jerusalem",
        "isVid": true,
        "isDouble": false,
        "vidId":"V0Acsw3Hf_M",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "The_Gates_Of_Jerusalem"
    },

    {
        "title": "القدس كما لم تروها من قبل",
        // "sml_desc": "Modern luxuries for the pampered traveler",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/Jerusalem/45.jpg",
        "side_img": "/PostCarousel/Jerusalem/45.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=45",
        "isVid": false,
        "isDouble": false,
        "ctg": "jerusalem",
        "id": 45
    },
    
    {
        // "title": "A Foodie’s Paradise‘",
        "title" : "مذاق شهي، بكل بساطة",
        // "sml_desc": "Check out Tel Aviv’s \n awesome culinary Scene",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/99.jpg",
        "img_mob":"/PostCarousel/video_mob/99.jpg",
        "side_img": "/PostCarousel/99.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=21",
        "ctg": "culinarytelaviv",
        "vidId": "JQD9JpMaw9g",
        "isVid": true,
        "isDouble": false,
        "id": "Simply_Delicious"
    },
    
    {
        "title": "شواطئ رائعة",
        // "sml_desc": "Come chill by the sunny beaches",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        "side_img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=14",
        "isVid": false,
        // "vidId":"XDei1Zy_cu4",
        "forVidPage": false,
        "isDouble": false,
        "ctg": "telaviv",
        "id":"Sensational_Beaches"
    },
    {
         "title":"حيفا",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/haifa.jpg",
         "side_img":"/PostCarousel/haifa.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Haifa", 
         "css_class":"unic-post-haifa",
         "isVid" : true,
         "isDouble": false,
         "vidId":"3ahATaKkhBk",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Haifa'
   },

   // Hadar asked to hide the video at Jerusalem Furn post on 2021-02-04
   {
       "title": "متعة القدس",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jerusalem_Fun",
        "isVid": false,
        "isDouble": false,
        "vidId": "FvAWuLQEOJw",
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Jerusalem_Fun"
    },
    // End Hadar asked to hide the video at Jerusalem Furn post on 2021-02-04



    {
        "title": "حياة ليلية مجنونة",
        // "sml_desc": " Book your trip to Tel Aviv!",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/crazy-night.jpg",
        "img_mob":"/Videos/video_mob/crazy-night.jpg",
        "side_img": "Videos/sidebar/crazy-night.jpg",
        "read_more": "READ MORE",
        "vidId": "",
        "ctg": "telaviv",
        "isDouble": false,
        "isVid": false,
        "id": "Amazing_Nightlife"
    },
    {
       "title": "الفنّ في القدس",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jerusalem_Arts",
        "isVid": false,
        "isDouble": false,
        "ctg": "jerusalem",
        "id": "Jerusalem_Arts"
    },
    {
         "title":"إثارة في الجليل",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilee-action.jpg",
         "side_img":"/PostCarousel/galilee-action.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Galilee_Action", 
         "css_class":"unic-post-galilee-action",
         "isVid" : true,
         "isDouble": false,
         "vidId":"5Ep3GgxELag",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Galilee_Action'
        },
    {
        "title": "متع التسوق",
        // "sml_desc": "From culture to souvenirs",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/5.jpg",
        "side_img": "/PostCarousel/5.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Shopping_Delights",
        "ctg": "jerusalem",
        // "isVid": false,
        "isVid": true,
        "isDouble": false,
        "vidId":"V0Acsw3Hf_M",
        "forVidPage": true,
        "id": "Shopping_Delights"
    },
    {
         "title":"الناصرة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/nazareth.jpg",
         "side_img":"/PostCarousel/nazareth.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Nazareth", 
         "css_class":"unic-post-nazareth",
         "isVid" : true,
         "isDouble": false,
         "vidId":"1M7N5BcmjFM",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Nazareth'
        },
        {
         "title":"ذكرى تدوم مدى الحياة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "side_img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Eilat_Doolphin_Reef", 
         "css_class":"unic-post-eilat-doolphin-reef",
         "isVid" : true,
         "vidId":"3Cvz8GoxNzA",
         // "isVid": false,
         "forVidPage": true,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Eilat_Doolphin_Reef'
        },
        {
          "title": "متحف برج داود",
          "sml_desc": "",
          "img": "thingsToDo/7.jpg",
          "side_img": "thingsToDo/sidebar/7.jpg",
          "read_more": "READ MORE",
          "link": "/Posts/index.php?post=20",
          "css_class": "unic_video-post-1",
          "vidId": "88OV6xU0vPI",
          "isVid": false,
          "id": "Tower_Of_David_Museum",
          "showOnHome": false,
          "isDouble": false,
          "ctg": "jerusalem"

        },
        
        {
         "title":"الحداق الوطنية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/national-parks.jpg",
         "side_img":"/PostCarousel/national-parks.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=National_Parks", 
         "css_class":"unic-post-national-parks",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'general',
          "id"    : 'National_Parks'
        },
        {
          "title": "متحف \"ياد فا شيم\" الذي لا يُنسى",
          "sml_desc": "",
          "img": "thingsToDo/10.jpg",
          "side_img": "thingsToDo/sidebar/10.jpg",
          "read_more": "READ MORE",
          "link": "/Posts/index.php?post=20",
          "css_class": "unic_video-post-1",
          "vidId": "88OV6xU0vPI",
          "isVid": false,
          "isDouble": false,
          id: 31,
          "showOnHome": false,
          "ctg": "jerusalem"

        },
        {
         "title":"زخرون يعقوب",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/zichron-yaakov.jpg",
         "side_img":"/PostCarousel/zichron-yaakov.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Zichron_Yaakov", 
         "css_class":"unic-post-zichron-yaakov",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'north',
          "id"    : 'Zichron_Yaakov'
        },
        {
          "title": "متع يافا",
          "sml_desc": "",
          // "sml_desc" : "Ancient, Artsy and Fabulous",
          "desc": "",
           // "desc" : "Experience all the riches the beautiful ancient Jaffa has to offer",
          "img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
          "side_img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
          "read_more": "READ MORE",
          "link": "/Posts/index.php?post=Joys_Of_Jaffa",
          "isVid": true,
          "vidId":"tgF0zMUYY2g",
          // "isVid": false,
          "forVidPage": true,
          "isDouble": false,
          "ctg": "telaviv",
          "id": "Joys_Of_Jaffa"
      },
      {
         "title":"ايلات",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat1.jpg",
         "side_img":"/PostCarousel/eilat1.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=EILAT1", 
         "css_class":"unic-post-EILAT1",
        //  "isVid" : true,
        //  "vidId": "ZdnNT-GDJv4",
         "isVid": false,
         "forVidPage": false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'EILAT1'
      },
      {
        "title": "مذاق من القدس",
        // "sml_desc": "Must eat dishes to try when visiting the magical city",
        "desc": "",
        "sml_desc": "",
        "img": "/PostCarousel/37.jpg",
         "img_mob":"/PostCarousel/video_mob/37.jpg",
        "side_img": "/PostCarousel/37.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=38",
        "ctg": "culinary",
        "vidId": "2CSCe2WC7Ns",
        "isVid": true,
        "isDouble": false,
        "id": "A_Taste_Of_Jerusalem"
      },
      {
         "title":"طريق البخور",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-incense-route.jpg",
         "side_img":"/PostCarousel/the-incense-route.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Incense_Route", 
         "css_class":"unic-post-the-incense-route",
         "isVid" : true,
         "isDouble": false,
         "vidId":"5AAqIhkq_tQ",
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'The_Incense_Route'
        },
        {
            "title": "استمتعوا.. انغمسوا!",
            // "sml_desc": "Enjoy and Indulge",
            "sml_desc": "",
            // "desc": "Tel Aviv - The ultimate luxury destination",
            "desc": "",
            "img": "/PostCarousel/36.jpg",
            "side_img": "/PostCarousel/36.jpg",
            "read_more": "READ MORE",
            "link": "/Posts/index.php?post=37",
            "ctg": "telaviv",
            "isDouble": false,
            "isVid": false,
            "id": 37
        },
        {
          "title": "جميع الأسواق المبهرة",
          "sml_desc": "",
          "desc": "",
          "img": "thingsToDo/8.jpg",
          "side_img": "thingsToDo/sidebar/8.jpg",
          "read_more": "READ MORE",
          "link": "/Posts/index.php?post=20",
          "css_class": "unic_video-post-1",
          "vidId": "88OV6xU0vPI",
          "isVid": false,
          "isDouble": false,
          "id": "All_Sensory_Markets",
          "showOnHome": false,
          "ctg": "jerusalem"

      },
      {
        "title": "نفيه تصيدق",
        "sml_desc": "",
        // "sml_desc" : "Chic and Unique  ",
        // "desc": "Packed with Lovely Cafe’s, Boutique shops, Art galleries, Elegance and chilled vibes ",
         "desc": "",
        "img": "Videos/j.jpg",
        "img_mob":"/Videos/video_mob/j.jpg",
        "side_img": "Videos/sidebar/j.jpg",
        "read_more": "READ MORE",
        "vidId": "5jl13Z-38eE",
        "link": "/Posts/index.php?postType=video&post=7",
        "css_class": "unic_video-post-13",
        "ctg": "telaviv",
        "isVid": true,
        "isDouble": false,
        "id": "Neve_Tzedek"
      },
      {
         "title":"الإثارة  في إيلات",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/action-packed-eilat.jpg",
         "side_img":"/PostCarousel/action-packed-eilat.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Action_Packed_Eilat", 
         "css_class":"unic-post-action-packed-eilat",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Action_Packed_Eilat'
      },
      {
         "title":"صفد، حيث يلتقي عالم  الغموض بالعالم الدنيوي",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/safed.jpg",
         "side_img":"/PostCarousel/safed.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Safed", 
         "css_class":"unic-post-safed",
         "isVid" : true,
         "isDouble": false,
         "vidId":"i3_ihL51bHo",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Safed'
        },
        
        {
          "title": "جيمي أوليفر في تل أبيب",
          // "sml_desc": "Jamie Oliver gets a taste of Tel Aviv's breakfast",
          "sml_desc": "",
          "desc": "",
          "img": "Videos/jamie-oliver.jpg",
          "img_mob":"/Videos/video_mob/jamie-oliver.jpg",
          "side_img": "Videos/sidebar/jamie-oliver.jpg",
          "vidId": "gGe4W8WaIiQ",
          "read_more": "READ MORE",
          "link": "/Posts/index.php?post=Jamie_Oliver",
          "ctg": "culinary",
          "isVid": true,
          "isDouble": false,
          "id": "Jamie_Oliver"
      },
      {
        "title": "التجوال بالدراجة الهوائية في تل أبيب",
        // "desc": "Get on your bicycle -<br> explore the city in style",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/39.jpg",
        "side_img": "PostCarousel/39.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=38",
        "ctg": "telaviv",
        "isVid": true,
        "isDouble": false,
        "vidId": "5nqL-oIC0GA",
        // "isVid": false,
        "forVidPage": true,
        "id": "Cycle_TelAviv"
    },
      
    
    
    
    
    
    
    // End NEW for EU
    
    // {
    //       "title": "إثارة بلا توقف",
    //       // "sml_desc": "unforgettable Tel Aviv ",
    //       "sml_desc": "",
    //       "desc": "",
    //       "img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    //       "side_img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    //       "read_more": "READ MORE",
    //       "link": "/Posts/index.php?post=Nonstop_Excitement",
    //       "ctg": "telaviv",
    //       "isVid": true,
    //       "isDouble": false,
    //       "vidId": "88OV6xU0vPI",
    //       // "isVid": false,
    //       "forVidPage": true,
    //       "id": "Nonstop_Excitement"
    // },
   
    {
        "title": "تل-أبيب يافا",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/post-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/post-telaviv.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Tel_Aviv",
        "isVid": false,
        // "vidId": "I9a4BFWO_6w",
        // "isVid": false,
        "forVidPage": false,
        "isDouble": false,
        "ctg": "telaviv",
        "id": "Tel_Aviv"
    },
    //Hadar asked to hide this post on 2021-02-01
    // {
    //    "title": "البلدة القديمة في القدس",
    //     "sml_desc" : "",
    //      // "sml_desc": "Jerusalem’s Old City",
    //      "desc" : "",
    //      // "desc": "Sensational sites of Ancient Times",
    //     "img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/jerusalem-old-city.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Jerusalem_Old_City",
    //     "isVid": false,
    //     "isDouble": false,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_Old_City"
    // },
    // end Hadar asked to hide this post on 2021-02-01
    // {
    //    "title": "بهاء الطبيعة",
    //     // "sml_desc": "THE DEAD SEA",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/DeadSea/natures-glory.jpg",
    //     "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Natures_Glory",
    //     "isVid": true,
    //     "vidId": "M627s8TdaB8",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "isDouble": false,
    //     "ctg": "deadsea",
    //     "id": "Natures_Glory"
    // },
    
    
     

    // This post is double for complitting the JERUSALEM carousel in mobile
    // {
    //    "title": "أطباق يجب تناولها في القدس",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Must_Eat_In_Jerusalem",
    //     "isVid": true,
    //     "vidId": "2CSCe2WC7Ns",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "isDouble": true,
    //     "ctg": "jerusalem",
    //     "id": "Must_Eat_In_Jerusalem"
    // },
    // END This post is double for complitting the JERUSALEM carousel in mobile

    // {
    //     "title": "Amazing Nightlife",
    //     "sml_desc": "",
    //     // "sml_desc": "Amazing Nightlife",
    //     "desc": "",
    //     // "desc": "It’s a never-ending party<br> in the nonstop city!",
    //     "img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    //     "side_img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Amazing_Nightlife",
    //     "isVid": true,
    //     "vidId":"ogEN7aRT0SM",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "isDouble": false,
    //     "ctg": "telaviv",
    //     "id": "Amazing_Nightlife"
    // },

    
    
    

    
    // {
    //     "title": "التمتع في القدس بعد حلول المساء",
    //     // "sml_desc": "A city beyond expectations",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/38.jpg",
    //     "side_img": "/PostCarousel/38.jpg",
    //     "read_more": "READ MORE",
    //     "link": this.url + "/Posts/index.php?post=Cool_Jerusalem",
    //     "ctg": "jerusalem",
    //     "isVid": true,
    //     "vidId":"FvAWuLQEOJw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "isDouble": false,
    //     "id": "Cool_Jerusalem"
    // },
    
   
    // {
    //     "title": "حمّى التسوّق",
    //     // "sml_desc": "Market Madness",
    //     "sml_desc": "",
    //     // "desc": "Night time celebration in <br>Jerusalem’s Mahane Yehuda",
    //     "desc": "",
    //     "img": "Videos/market-madness.jpg",
    //     "img_mob":"/Videos/video_mob/market-madness.jpg",
    //     "side_img": "Videos/sidebar/market-madness.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Market_Madness",
    //     "vidId": "2CSCe2WC7Ns",
    //     "ctg": "jerusalem",
    //     "isVid": true,
    //     "isDouble": false,
    //     "id": "Market_Madness"
    // },


    
    //  {
    //     "title": "التوجه إلى دليل سياحي",
    //     // "sml_desc": "Travel from Tel Aviv and Jerusalem",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/34.jpg",
    //     "side_img": "/PostCarousel/34.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=35",
    //     "ctg": "telaviv",
    //     "isVid": false,
    //     "isDouble": false,
    //     // "id": 35
    //     "id": "Go_To_Guide"
    // },

    // Hadar asked to hide this post on 2021-02-01
    // {
    //     "title": "القدس",
    //     // "sml_desc": "THE HEART OF THE WORLD",
    //     "sml_desc": "",
    //     // "desc": "",
    //     "desc": "",
    //     "img": "Videos/heart-of-the-world.jpg",
    //     "img_mob":"/Videos/video_mob/heart-of-the-world.jpg",
    //     "side_img": "Videos/sidebar/heart-of-the-world.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Heart_Of_The_World",
    //     "vidId": "FvAWuLQEOJw",
    //     "ctg": "jerusalem",
    //     "isVid": true,
    //     "isDouble": false,
    //     "id": "Heart_Of_The_World"
    // },
    // end Hadar asked to hide this post on 2021-02-01
    
    // {
    //     "title": "المعالم البارزة في تل أبيب",
    //     // "sml_desc": "Top 5 things to see and\n do in the city",
    //      "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/17.jpg",
    //     "side_img": "/PostCarousel/17.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=17",
    //     "ctg": "telaviv",
    //     "vidId": "tgF0zMUYY2g",
    //     "isVid": true,
    //     "isDouble": false,
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "id": "Tel-Aviv_Highlights"
    // },
    // {
    //     "title": "زيارتكم الأولى إلى القدس",
    //     // "sml_desc": "The must list for the first time visitor",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=First_Time_In_Jerusalem",
    //     "isVid": true,
    //     "vidId":"FvAWuLQEOJw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "isDouble": false,
    //     "ctg": "jerusalem",
    //     "id": "First_Time_In_Jerusalem"
    // },
    
    
    
    // {
    //    "title": "أسرار القدس",
    //     "sml_desc" : "",
    //      "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Sectrets_Of_Jewish_Jerusalem",
    //     "isVid": false,
    //     "isDouble": false,
    //     "ctg": "jerusalem",
    //     "id": "Sectrets_Of_Jewish_Jerusalem"
    // },
    
    
    
    
    
    
    
    // {
    //    "title": "أطباق يجب تناولها في القدس",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Must_Eat_In_Jerusalem",
    //     "isVid": true,
    //     "isDouble": false,
    //     "vidId": "2CSCe2WC7Ns",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id": "Must_Eat_In_Jerusalem"
    // },
    {
        "title": "المشهد الخُضري في تل أبيب",
        // "sml_desc": "Voted # 1 Vegan destination in the world  ",
        // "desc": "Enjoy the huge choice of vegan",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/h.jpg",
        "img_mob":"/Videos/video_mob/h.jpg",
        "side_img": "Videos/sidebar/h.jpg",
        "vidId": "9l04RfZ95J0",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=6",
        "ctg": "culinary",
        "isVid": true,
        "isDouble": false,
        "id": "Vegan_Friendly_TelAviv"
    },
    
    // {
    //     "title": "مغامرات تل أبيب",
    //     // "sml_desc": "Cool things to do in the hot city",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/40.jpg",
    //     "side_img": "/PostCarousel/40.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=TelAviv_Adventures",
    //     "ctg": "telaviv",
    //     "isVid": false,
    //     "isDouble": false,
    //     "id": "TelAviv_Adventures"
    // },
    
    {
        "title": "سارونا تل أبيب",
        "desc": "",
        // "desc": "A huge selection of attractions  <br/> in a stunningly renovated Templar colony",
        // "sml_desc": "A stunning urban oasis",
        "sml_desc": "",
        "img": "Videos/d.jpg",
        "img_mob":"/Videos/video_mob/d.jpg",
        "side_img": "Videos/sidebar/d.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=Sarona_TelAviv",
        "vidId": "MJ-gsGs1tqA",
        "ctg": "telaviv",
        "isVid": true,
        "isDouble": false,
        "id": "Sarona_TelAviv"
    },
    
    // {
    //     "title": "رحلات نهارية",
    //     "sml_desc": "",
    //     // "sml_desc" : "Day isTrippin’",
    //     "desc": "",
    //      // "desc" : "Fabulous and fascinating one day in Tel Aviv",
    //     "img": "/PostCarousel/TelAviv/day-is-trippin.jpg",
    //     "side_img": "/PostCarousel/TelAviv/day-is-trippin.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Day_IsTrippin",
    //     "isVid": false,
    //     "isDouble": false,
    //     "ctg": "telaviv",
    //     "id": "Day_IsTrippin"
    // },
    // {
    //      "title":"استكشفوا  مسارات النبيذ",
    //      "sml_desc":"",
    //      "desc":"",
    //      "img":"/PostCarousel/discover-the-wine-routes.jpg",
    //      "img_mob":"/PostCarousel/video_mob/discover-the-wine-routes.jpg",
    //      "side_img":"/PostCarousel/discover-the-wine-routes.jpg",
    //      "read_more":"READ MORE",
    //      "link": "/Posts/index.php?post=Discover_The_Wine_Routes", 
    //      "css_class":"unic-post-discover-the-wine-routes",
    //      "isVid" : true,
    //      "isDouble": false,
    //      "vidId":"Cxii1yKqKwI",
    //      // "isVid": false,
    //      "forVidPage": true,
    //      "ctg"   : 'culinarynorth',
    //       "id"    : 'Discover_The_Wine_Routes'
    // },
    // {
    //     "title": "أهمّ المواقع في القدس",
    //     // "sml_desc": "Travel back thousands of years",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=9",
    //     "isVid": true,
    //     "isDouble": false,
    //     "vidId":"k4OwoEk5wMw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id":"Jerusalem_Main_Sites"
    // },
    {
        "title": "جورميه تل أبيب",
        // "sml_desc": "The perfect place\n to treat yourself",
        "sml_desc": "",
        // "desc": "Tel Aviv's huge variety of amazing",
        "desc": "",
        "img": "Videos/gourmet-telaviv.jpg",
        "img_mob":"/Videos/video_mob/gourmet-telaviv.jpg",
        "side_img": "Videos/sidebar/gourmet-telaviv.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=33",
        "vidId": "jfyHxk8ZRrI",
        "ctg": "culinary",
        "isVid": true,
        "isDouble": false,
        "id": "Gourmet_TelAviv"
    },
   
    // {
    //     "title": "السفر بميزانية محدودة",
    //     // "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/44.jpg",
    //     "side_img": "/PostCarousel/44.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=44",
    //     "isVid": false,
    //     "isDouble": false,
    //     "ctg": "telaviv",
    //     "id": 44
    // },


    // Hadar asked to hide this post on 2021-02-08
    // {
    //    "title": "المشتريات في إسرائيل",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/unique.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/unique.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Purchases_In_Israel",
    //     "isVid": false,
    //     "isDouble": false,
    //     "ctg": "jerusalem",
    //     "id": "Purchases_In_Israel"
    // },
    // End Hadar asked to hide this post on 2021-02-08




    //Hadar asked to hide this post on 2021-02-08
    // {
    //    "title" : "طعام الشوارع السريع في تل أبيب",
    //     // "sml_desc" : "Tel Aviv street food",
    //     "sml_desc" : "",
    //     // "desc" : "A true world-class foodie destination",
    //      "desc" : "",
    //     "img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    //     "side_img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Tel_Aviv_Street_Food",
    //     "isVid": true,
    //     "isDouble": false,
    //     "vidId":"JQD9JpMaw9g",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "telaviv",
    //     "id": "Tel_Aviv_Street_Food"
    // },
    //end Hadar asked to hide this post on 2021-02-08

    {
       "title" : "الإفطار في إسرائيل",
        // "sml_desc" : "A LEGEND IN ITS OWN MEALTIME",
        "sml_desc" : "",
        // "desc" : "",
         "desc" : "",
        "img": "/PostCarousel/Culinary/breackfast-in-israel.jpg",
        "img_mob":"/PostCarousel/video_mob/breackfast-in-israel.jpg",
        "side_img": "/PostCarousel/Culinary/breackfast-in-israel.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Breakfast-In-Israel",
        "isVid": true,
        "isDouble": false,
        "vidId":"JJ7PhOw1p5E",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "culinary",
        "id": "Breakfast-In-Israel"
    },
    
    
    
    // {
    //     "title": "التمتع بالشاطئ لأقصى حد",
    //     "sml_desc": "",
    //     // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "img_mob":"/PostCarousel/video_mob/ultimate-beaches.jpg",
    //     "side_img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=24",
    //     "css_class": "unic_video-post-1",
    //     // "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "isDouble": false,
    //     "id":"Ultimate_Beach_Fun",
    //     "ctg": "telaviv",
    //     "showOnHome": false,
    // },


    //Hadar asked to hide this post on 2021-02-01
    // {
    //     "title": "حديثة ونابضة بالحياة",
    //     // "sml_desc": "So much to see in Jerusalem’s",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/19.jpg",
    //     "side_img": "/PostCarousel/19.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Modern_And_Vibrant",
    //     "isVid": true,
    //     "isDouble": false,
    //     "vidId": "V0Acsw3Hf_M",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id": "Modern_And_Vibrant"
    // },
    // end Hadar asked to hide this post on 2021-02-01

    
    
    // {
    //    "title": "التمتع في القدس بعد حلول المساء",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
    //     "isVid": true,
    //     "isDouble": false,
    //     "vidId":"FvAWuLQEOJw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_After_Dark_Fun"
    // },
    
     
    

    

    // {
    //     "title": "ALL SENSORY MARKETS",
    //     "sml_desc": "",
    //     "img": "thingsToDo/8.jpg",
    //     "side_img": "thingsToDo/sidebar/8.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": true,
    //     // "isVid": false,
    //     "id": "All_Sensory_Markets",
    //     "showOnHome": false,
    //     "ctg": "culinary"

    // },
    
    
   
    


    
    // {
    //     "title": "عاصمة الحفلات",
    //     // "sml_desc": "Epic Nights in the non stop city",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/42.jpg",
    //     "side_img": "/PostCarousel/42.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=42",
    //     "isVid": true,
    //     // "vidId":"ogEN7aRT0SM",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "isDouble": false,
    //     "ctg": "telaviv",
    //     "id": "Party_Capital"
    // },
    
    
    // {
    //    "title": "متع الميناء",
    //     // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
    //     "sml_desc" : "",
    //     // "desc": "Tel Aviv’s fascinating cultural scene",
    //     "desc" : "",
    //     "img": "/PostCarousel/TelAviv/post-pleasures.jpg",
    //     "side_img": "/PostCarousel/TelAviv/post-pleasures.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Port_Pleasures",
    //     "isVid": true,
    //     "vidId": "tgF0zMUYY2g",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "isDouble": false,
    //     "ctg": "telaviv",
    //     "id": "Port_Pleasures"
    // },

    // Three posts for Tel aviv carousel mobile version
   
    {
        "title": "ضيافة فاخرة",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
        "side_img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Boutique_Hospitality",
        "isVid": false,
        "isDouble": true,
        "ctg": "telaviv",
        "id": "Boutique_Hospitality"
    },
    
    // {
    //     "title": "التمتع بالشاطئ لأقصى حد",
    //     "sml_desc": "",
    //     // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "img_mob":"/PostCarousel/video_mob/ultimate-beaches.jpg",
    //     "side_img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=24",
    //     "css_class": "unic_video-post-1",
    //     // "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "isDouble": true,
    //     "id":"Ultimate_Beach_Fun",
    //     "ctg": "telaviv",
    //     "showOnHome": false,

    // },
  
    

    

    // Three posts for DAED SEA carousel mobile version
     
    {
       "title": "ظاهرة طبيعية",
        // "sml_desc": "THE DEAD SEA",
         "sml_desc": "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
        "img_mob":"/PostCarousel/video_mob/natural-phenomena.jpg",
        "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Natural_Phenomena",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": true,
        "ctg": "deadsea",
        "id": "Natural_Phenomena"
    },
   
    // END Three posts for DEAD SEA carousel mobile version

   

    // Eilat Posts
        
        // {
        //  "title":"أهلا بكم في إيلات",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/welcome-to-eilat.jpg",
        //  "side_img":"/PostCarousel/welcome-to-eilat.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Welcome_To_Eilat", 
        //  "css_class":"unic-post-welcome-to-eilat",
        // //  "isVid" : true,
        // //  "vidId":"ZdnNT-GDJv4",
        //  "isVid": false,
        //  "forVidPage": false,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Welcome_To_Eilat'
        // },
        // {
        //  "title":"التمتع بالعطلة إلى أقصى حدّ",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/the-ultimate-holiday.jpg",
        //  "side_img":"/PostCarousel/the-ultimate-holiday.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Ultimate_Holiday", 
        //  "css_class":"unic-post-the-ultimate-holiday",
        //  "isVid" : false,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'The_Ultimate_Holiday'
        // },
        // {
        //  "title":"إيلات تناديكم",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/eilat-calling.jpg",
        //  "side_img":"/PostCarousel/eilat-calling.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Eilat_Calling", 
        //  "css_class":"unic-post-eilat-calling",
        // //  "isVid" : true,
        // //  "vidId":"ZdnNT-GDJv4",
        //  "isVid": false,
        //  "forVidPage": false,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Eilat_Calling'
        // },
        
        
        // {
        //  "title":"الشاطئ الأمثل في إيلات",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/eilat-ultimate-beachside.jpg",
        //  "side_img":"/PostCarousel/eilat-ultimate-beachside.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Eilat_Ultimate_Beachside", 
        //  "css_class":"unic-post-eilat-ultimate-beachside",
        // //  "isVid" : true,
        // //  "vidId":"ZdnNT-GDJv4",
        //  "isVid": false,
        //  "forVidPage": false,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Eilat_Ultimate_Beachside'
        // },
        // {
        //  "title":"يوم واحد في إيلات",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/one-day-in-eilat.jpg",
        //  "side_img":"/PostCarousel/one-day-in-eilat.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=One_Day_In_Eilat", 
        //  "css_class":"unic-post-one-day-in-eilat",
        //  "isVid" : false,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'One_Day_In_Eilat'
        // },
        {
         "title":"صحراء إسرائيل الساحرة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/majestic-desert.jpg",
         "side_img":"/PostCarousel/majestic-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Majestic_Desert", 
         "css_class":"unic-post-majestic-desert",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Majestic_Desert'
        },
        // {
        //  "title":"النقب",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/negev.jpg",
        //  "side_img":"/PostCarousel/negev.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Negev1", 
        //  "css_class":"unic-post-negev",
        //  "isVid" : true,
        //  "vidId":"yXzhH92kREg",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Negev1'
        // },
        // {
        //  "title":"الموقع  وطريقة الوصول",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/location-and-approach.jpg",
        //  "side_img":"/PostCarousel/location-and-approach.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Location_And_Approach", 
        //  "css_class":"unic-post-location-and-approach",
        //  "isVid" : true,
        //  "vidId":"5AAqIhkq_tQ",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Location_And_Approach'
        // },
        {
         "title":"المبيت في النقب",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/stay-in-the-negev.jpg",
         "side_img":"/PostCarousel/stay-in-the-negev.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Stay_In_The_Negev", 
         "css_class":"unic-post-stay-in-the-negev",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Stay_In_The_Negev'
        },
        // {
        //  "title":"نقاء السحر في الصحراء",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/pure-desert-magic.jpg",
        //  "side_img":"/PostCarousel/pure-desert-magic.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Pure_Desert_Magic", 
        //  "css_class":"unic-post-pure-desert-magic",
        //  "isVid" : false,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Pure_Desert_Magic'
        // },
        {
         "title":"متعة المغامرة في الصحراء الإسرائيلية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "side_img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Action_Fun_In_The_Desert", 
         "css_class":"unic-post-action-fun-in-the-desert",
         "isVid" : true,
         "isDouble": false,
        "vidId":"yXzhH92kREg",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Action_Fun_In_The_Desert'
        },
        
        {
         "title":"جبل كركم",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/mount-karkom.jpg",
         "side_img":"/PostCarousel/mount-karkom.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Mount_Karkom", 
         "css_class":"unic-post-mount-karkom",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Mount_Karkom'
        },
        {
         "title":"مختيش رامون",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/machtes-ramon.jpg",
         "side_img":"/PostCarousel/machtes-ramon.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Machtesh_Ramon", 
         "css_class":"unic-post-machtes-ramon",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Machtesh_Ramon'
        },
        // {
        //  "title":"مسادا الأسطورية",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/epic-masada.jpg",
        //  "side_img":"/PostCarousel/epic-masada.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Epic_Masada", 
        //  "css_class":"unic-post-epic-masada",
        //  "isVid" : true,
        //  "isDouble": false,
        //  "vidId":"XxWa_MNm5x8",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Epic_Masada'
        // },
        // {
        //  "title":"التجربة البدوية",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/the-bedouin-experience.jpg",
        //  "side_img":"/PostCarousel/the-bedouin-experience.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Bedouin_Experience", 
        //  "css_class":"unic-post-the-bedouin-experience",
        //  "isVid" : false,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'The_Bedouin_Experience'
        // },
        
        {
         "title":"كنوز \"تيمنع\"",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/timna-treasures.jpg",
         "side_img":"/PostCarousel/timna-treasures.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Timna_Treasures", 
         "css_class":"unic-post-timna-treasures",
         "isVid" : true,
         "isDouble": false,
         "vidId":"i_4QKtXIeto",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Timna_Treasures'
        },
        // {
        //  "title":"صحراء النقب: لا تفوّتوها",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/negev-desert-dont-miss.jpg",
        //  "side_img":"/PostCarousel/negev-desert-dont-miss.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Negev_Desert_Dont_Miss", 
        //  "css_class":"unic-post-negev-desert-dont-miss",
        //  "isVid" : false,
        //  "isDouble": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Negev_Desert_Dont_Miss'
        // },
        // {
        //  "title":"سحر النقب",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/negev-charms.jpg",
        //  "side_img":"/PostCarousel/negev-charms.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Negev_Charms", 
        //  "css_class":"unic-post-negev-charms",
        //  "isVid" : true,
        //  "isDouble": false,
        //  "vidId":"3UddwPEzDXo",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Negev_Charms'
        // },
        // End Eilat Posts


        // North Posts
        
        
        
        
        
        // Hadar asked to hide this post The_Sea_Of_Galilee on 2021-02-04
        // {
        //  "title":"(بحيرة الجليل) طبريا",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/sea-of-galilee.jpg",
        //  "side_img":"/PostCarousel/sea-of-galilee.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Sea_Of_Galilee", 
        //  "css_class":"unic-post-sea-of-galilee",
        //  "isVid" : true,
        //  "isDouble": false,
        //  "vidId":"haG-t3wwuMc",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "ctg"   : 'north',
        //   "id"    : 'The_Sea_Of_Galilee'
        // },
        // End Hadar asked to hide this post The_Sea_Of_Galilee on 2021-02-04
        
        
        // {
        //  "title":"نخب إسرائيل",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/cheers-to-israel.jpg",
        //  "img_mob":"/PostCarousel/video_mob/cheers-to-israel.jpg",
        //  "side_img":"/PostCarousel/cheers-to-israel.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Cheers_To_Israel", 
        //  "css_class":"unic-post-cheers-to-israel",
        //  "isVid" : true,
        //  "isDouble": false,
        //  "vidId":"Cxii1yKqKwI",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "ctg"   : 'culinarynorth',
        //   "id"    : 'Cheers_To_Israel'
        // },
       
        {
         "title":"متعة جليلية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilean-treat.jpg",
         "img_mob":"/PostCarousel/video_mob/galilean-treat.jpg",
         "side_img":"/PostCarousel/galilean-treat.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=A_Galilean_Treat", 
         "css_class":"unic-post-galilean-treat",
         "isVid" : true,
         "isDouble": false,
         "vidId":"kF808ENuuTQ",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'culinary',
          "id"    : 'A_Galilean_Treat'
        },

]


export const newVideos = [

    {
         "title":"مرصد الطيور في بحيرة الحولة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "img_mob":"/PostCarousel/video_mob/birdtastic-hula-lake.jpg",
         "side_img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Birdtastic_Hula_Lake", 
         "css_class":"unic-post-birdtastic-hula-lake",
         "isVid" : true,
         "vidId":"ImobrsxsKl8",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Birdtastic_Hula_Lake'
    },
    {
         "title":"الجليل",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilee.jpg",
         "img_mob":"/PostCarousel/video_mob/galilee.jpg",
         "side_img":"/PostCarousel/galilee.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Galilee", 
         "css_class":"unic-post-galilee",
         "isVid" : true,
         "vidId":"5Ep3GgxELag",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Galilee'
    },

    {
       "title": "متسادا",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/masada.jpg",
        "img_mob":"/PostCarousel/video_mob/masada.jpg",
        "side_img": "/PostCarousel/DeadSea/masada.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Masada",
        "isVid": true,
        "vidId": "XxWa_MNm5x8",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "deadsea",
        "id": "Masada"
    },
    {
         "title":"عكا",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/acre.jpg",
         "img_mob":"/PostCarousel/video_mob/acre.jpg",
         "side_img":"/PostCarousel/acre.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Acre", 
         "css_class":"unic-post-acre",
         "isVid" : true,
         "vidId":"KlXXyToCmCM",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'general',
          "id"    : 'Acre'
       },
    {
         "title":"روش بينا",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/rosh-pina.jpg",
         "img_mob":"/PostCarousel/video_mob/rosh-pina.jpg",
         "side_img":"/PostCarousel/rosh-pina.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Rosh_Pina", 
         "css_class":"unic-post-rosh-pina",
         "isVid" : true,
         "vidId":"_qKbHL5-qrQ",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Rosh_Pina'
    },
     {
         "title":"قيسارية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/caesarea.jpg",
         "img_mob":"/PostCarousel/video_mob/caesarea.jpg",
         "side_img":"/PostCarousel/caesarea.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Caesarea", 
         "css_class":"unic-post-caesarea",
         "isVid" : true,
         "vidId":"eLZ433_S6HI",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Caesarea'
    },

    {
         "title":"حدائق البهائيين المذهلة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/bahai-gardens.jpg",
         "img_mob":"/PostCarousel/video_mob/bahai-gardens.jpg",
         "side_img":"/PostCarousel/bahai-gardens.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Bahai_Gardens", 
         "css_class":"unic-post-bahai-gardens",
         "isVid" : true,
         "vidId":"JV_AmfRULOo",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'The_Bahai_Gardens'
    },
    {
       "title": "جادة مأمن الله",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "img_mob":"/PostCarousel/video_mob/jerusalem.jpg",
        "side_img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Mamilla_Avenue",
        "isVid": true,
        "vidId": "V0Acsw3Hf_M",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Mamilla_Avenue"
    },


    // Hadar asked to hide the video inside this post on 2021-02-04
    // {
    //     "title": "أمور يجب عليكم تجربتها في القدس",
    //     // "sml_desc": "5 things to do in the stunning city",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/18.jpg",
    //     "img_mob":"/PostCarousel/video_mob/jerusalem-musts.jpg",
    //     "side_img": "/PostCarousel/18.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Jerusalem_Musts",
    //     "isVid": true,
    //     "vidId": "FvAWuLQEOJw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_Musts"
    // },
    // End Hadar asked to hide the video inside this post on 2021-02-04
    {
       "title": "سحر البحر الميت",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/magical-deadsea.jpg",
        "img_mob":"/PostCarousel/video_mob/magical-deadsea.jpg",
        "side_img": "/PostCarousel/DeadSea/magical-deadsea.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Magical_Deadsea",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "deadsea",
        "id": "Magical_Deadsea"
    },
    {
       "title": "بوابات القدس",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/gates.jpg",
        "img_mob":"/PostCarousel/video_mob/gates.jpg",
        "side_img": "/PostCarousel/Jerusalem/gates.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=The_Gates_Of_Jerusalem",
        "isVid": true,
        "vidId":"V0Acsw3Hf_M",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "The_Gates_Of_Jerusalem"
    },
    {
         "title":"صفد، حيث يلتقي عالم  الغموض بالعالم الدنيوي",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/safed.jpg",
         "img_mob":"/PostCarousel/video_mob/safed.jpg",
         "side_img":"/PostCarousel/safed.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Safed", 
         "css_class":"unic-post-safed",
         "isVid" : true,
         "vidId":"i3_ihL51bHo",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Safed'
    },
    {
       "title": "القدس",
        "sml_desc" : "",
         "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem.jpg",
        "img_mob":"/PostCarousel/video_mob/jerusalem.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jerusalem",
        "isVid": true,
        "vidId": "FvAWuLQEOJw",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Jerusalem"
    },
    {
         "title":"حيفا",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/haifa.jpg",
         "img_mob":"/PostCarousel/video_mob/haifa.jpg",
         "side_img":"/PostCarousel/haifa.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Haifa", 
         "css_class":"unic-post-haifa",
         "isVid" : true,
         "vidId":"3ahATaKkhBk",
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Haifa'
    },

    // Hadar asked to hide this video on this post on 2021-02-04
    // {
    //    "title": "متع الميناء",
    //     // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
    //     "sml_desc" : "",
    //     // "desc": "Tel Aviv’s fascinating cultural scene",
    //     "desc" : "",
    //     "img": "/PostCarousel/TelAviv/post-pleasures.jpg",
    //     "img_mob":"/PostCarousel/video_mob/post-pleasures.jpg",
    //     "side_img": "/PostCarousel/TelAviv/post-pleasures.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Port_Pleasures",
    //     "isVid": false,
    //     // "vidId": "tgF0zMUYY2g",
    //     "forVidPage": true,
    //     "ctg": "telaviv",
    //     "id": "Port_Pleasures"
    // },
    // End Hadar asked to hide this video on this post on 2021-02-04
    {
         "title":"إثارة في الجليل",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilee-action.jpg",
         "img_mob":"/PostCarousel/video_mob/galilee-action.jpg",
         "side_img":"/PostCarousel/galilee-action.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Galilee_Action", 
         "css_class":"unic-post-galilee-action",
         "isVid" : true,
         "vidId":"5Ep3GgxELag",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Galilee_Action'
        },
    {
        "title": "متع التسوق",
        // "sml_desc": "From culture to souvenirs",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/5.jpg",
        "img_mob":"/PostCarousel/video_mob/shopping-delights.jpg",
        "side_img": "/PostCarousel/5.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Shopping_Delights",
        "ctg": "jerusalem",
        // "isVid": false,
        "isVid": true,
        "vidId":"V0Acsw3Hf_M",
        "forVidPage": true,
        "id": "Shopping_Delights"
    },
    {
        "title": "نفيه تصيدق",
        "sml_desc": "",
        // "sml_desc" : "Chic and Unique  ",
        // "desc": "Packed with Lovely Cafe’s, Boutique shops, Art galleries, Elegance and chilled vibes ",
         "desc": "",
        "img": "Videos/j.jpg",
        "img_mob":"/Videos/video_mob/j.jpg",
        "side_img": "Videos/sidebar/j.jpg",
        "read_more": "READ MORE",
        "vidId": "5jl13Z-38eE",
        "link": "/Posts/index.php?postType=video&post=7",
        "css_class": "unic_video-post-13",
        "ctg": "telaviv",
        "isVid": true,
        "id": "Neve_Tzedek"
    },
    {
           "title":"ايلات",
           "sml_desc":"",
           "desc":"",
           "img":"/PostCarousel/eilat1.jpg",
           "img_mob":"/PostCarousel/video_mob/eilat1.jpg",
           "side_img":"/PostCarousel/eilat1.jpg",
           "read_more":"READ MORE",
           "link": "/Posts/index.php?post=EILAT1", 
           "css_class":"unic-post-EILAT1",
           "isVid" : false,
          //  "vidId": "ZdnNT-GDJv4",
           "forVidPage": false,
           "isDouble": true,
           "ctg"   : 'eilat-negev',
            "id"    : 'EILAT1'
    },
    {
         "title":"الناصرة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/nazareth.jpg",
         "img_mob":"/PostCarousel/video_mob/nazareth.jpg",
         "side_img":"/PostCarousel/nazareth.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Nazareth", 
         "css_class":"unic-post-nazareth",
         "isVid" : true,
         "vidId":"1M7N5BcmjFM",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Nazareth'
    },
    {
         "title":"طريق البخور",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-incense-route.jpg",
         "img_mob":"/PostCarousel/video_mob/the-incense-route.jpg",
         "side_img":"/PostCarousel/the-incense-route.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Incense_Route", 
         "css_class":"unic-post-the-incense-route",
         "isVid" : true,
         "vidId":"5AAqIhkq_tQ",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
         "id"    : 'The_Incense_Route'
    },
    {
        "title": "متع يافا",
        "sml_desc": "",
        // "sml_desc" : "Ancient, Artsy and Fabulous",
        "desc": "",
         // "desc" : "Experience all the riches the beautiful ancient Jaffa has to offer",
        "img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
        "img_mob":"/PostCarousel/video_mob/joys-of-jaffa.jpg",
        "side_img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Joys_Of_Jaffa",
        "isVid": true,
        "vidId":"tgF0zMUYY2g",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "telaviv",
        "id": "Joys_Of_Jaffa"
    },
    {
        "title": "التجوال بالدراجة الهوائية في تل أبيب",
        // "desc": "Get on your bicycle -<br> explore the city in style",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/39.jpg",
        "img_mob":"/PostCarousel/video_mob/cycle-telaviv.jpg",
        "side_img": "PostCarousel/39.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=38",
        "ctg": "telaviv",
        "isVid": true,
        "vidId": "5nqL-oIC0GA",
        // "isVid": false,
        "forVidPage": true,
        "id": "Cycle_TelAviv"
    },

    {
        "title": "مدينتان رائعتان",
        // "sml_desc": "One magical unforgettable getaway to the sun",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/General/tw-awesome-cities.jpg",
        "side_img": "/PostCarousel/General/tw-awesome-cities.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=42",
        "isVid": false,
        // "vidId": "b0QexDxEklA",
        // "isVid": false,
        "forVidPage": false,
        "ctg": "general",
        "id": "2_AWESOME_CITIES"
    },

    // Hadar asked to hide the video at Jerusalem Furn post on 2021-02-04
    // {
    //    "title": "متعة القدس",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
    //     "img_mob":"/PostCarousel/video_mob/jerusalem-fun.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Jerusalem_Fun",
    //     "isVid": true,
    //     "vidId": "FvAWuLQEOJw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_Fun"
    // },
    // End Hadar asked to hide the video at Jerusalem Furn post on 2021-02-04
    {
         "title":"ذكرى تدوم مدى الحياة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "img_mob":"/PostCarousel/video_mob/eilat-doolphin-reef.jpg",
         "side_img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Eilat_Doolphin_Reef", 
         "css_class":"unic-post-eilat-doolphin-reef",
         "isVid" : true,
         "vidId":"3Cvz8GoxNzA",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Eilat_Doolphin_Reef'
        },
    
    
    {
        "title": "تل أبيب",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/post-telaviv.jpg",
        "img_mob":"/PostCarousel/video_mob/post-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/post-telaviv.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Tel_Aviv",
        "isVid": false,
        // "vidId": "I9a4BFWO_6w",
        // "isVid": false,
        "forVidPage": false,
        "ctg": "telaviv",
        "id": "Tel_Aviv"
    },
   
    

   
   
     

    // {
    //     "title": "Amazing Nightlife",
    //     "sml_desc": "",
    //     // "sml_desc": "Amazing Nightlife",
    //     "desc": "",
    //     // "desc": "It’s a never-ending party<br> in the nonstop city!",
    //     "img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    //     "img_mob":"/PostCarousel/video_mob/amazing-nightlife.jpg",
    //     "side_img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Amazing_Nightlife",
    //     "isVid": true,
    //     "vidId":"ogEN7aRT0SM",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "telaviv",
    //     "id": "Amazing_Nightlife"
    // },
   
   
   
    // {
    //     "title": "التمتع في القدس بعد حلول المساء",
    //     // "sml_desc": "A city beyond expectations",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/38.jpg",
    //     "img_mob":"/PostCarousel/video_mob/cool-jerusalem.jpg",
    //     "side_img": "/PostCarousel/38.jpg",
    //     "read_more": "READ MORE",
    //     "link": this.url + "/Posts/index.php?post=Cool_Jerusalem",
    //     "ctg": "jerusalem",
    //     "isVid": true,
    //     "vidId":"FvAWuLQEOJw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "id": "Cool_Jerusalem"
    // },
    
   
    // {
    //     "title": "حمّى التسوّق",
    //     // "sml_desc": "Market Madness",
    //     "sml_desc": "",
    //     // "desc": "Night time celebration in <br>Jerusalem’s Mahane Yehuda",
    //     "desc": "",
    //     "img": "Videos/market-madness.jpg",
    //     "img_mob":"/Videos/video_mob/market-madness.jpg",
    //     "img_mob":"/Videos/video_mob/market-madness.jpg",
    //     "side_img": "Videos/sidebar/market-madness.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Market_Madness",
    //     "vidId": "2CSCe2WC7Ns",
    //     "ctg": "jerusalem",
    //     "isVid": true,
    //     "id": "Market_Madness"
    // },

    // this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked to transfer this post straight to "Amazing Nightlife"
    // {
    //     "title": "حياة ليلية مجنونة?",
    //     // "sml_desc": " Book your trip to Tel Aviv!",
    //     "sml_desc": "",
    //     // "desc": "",
    //     "desc": "",
    //     "img": "Videos/crazy-night.jpg",
    //     "img_mob":"/Videos/video_mob/crazy-night.jpg",
    //     "side_img": "Videos/sidebar/crazy-night.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Amazing_Nightlife",
    //     "vidId": "ogEN7aRT0SM",
    //     "ctg": "telaviv",
    //     "isVid": true,
    //     "id": "Amazing_Nightlife"
    // },
    // END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked to transfer this post straight to "Amazing Nightlife"

    //Hadar asked to hide this post on 2021-02-01
    // {
    //     "title": "القدس",
    //     // "sml_desc": "THE HEART OF THE WORLD",
    //     "sml_desc": "",
    //     // "desc": "",
    //     "desc": "",
    //     "img": "Videos/heart-of-the-world.jpg",
    //     "img_mob":"/Videos/video_mob/heart-of-the-world.jpg",
    //     "side_img": "Videos/sidebar/heart-of-the-world.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Heart_Of_The_World",
    //     "vidId": "FvAWuLQEOJw",
    //     "ctg": "jerusalem",
    //     "isVid": true,
    //     "id": "Heart_Of_The_World"
    // },
    //end  Hadar asked to hide this post on 2021-02-01
    {
       "title": "المنتجع الصحي الطبيعي: البحر الميت",
        "sml_desc" : "",
        // "sml_desc": "THE DEAD SEA",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/natural-spa.jpg",
        "img_mob":"/PostCarousel/video_mob/natural-spa.jpg",
        "side_img": "/PostCarousel/DeadSea/natural-spa.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Natural_Spa",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "deadsea",
        "id": "Natural_Spa"
    },
    
    // {
    //     "title": "المعالم البارزة في تل أبيب",
    //     // "sml_desc": "Top 5 things to see and\n do in the city",
    //      "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/17.jpg",
    //     "img_mob":"/PostCarousel/video_mob/telaviv-highlights.jpg",
    //     "side_img": "/PostCarousel/17.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=17",
    //     "ctg": "telaviv",
    //     "vidId": "tgF0zMUYY2g",
    //     "isVid": true,
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "id": "Tel-Aviv_Highlights"
    // },
    // {
    //     "title": "زيارتكم الأولى إلى القدس",
    //     // "sml_desc": "The must list for the first time visitor",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    //     "img_mob":"/PostCarousel/video_mob/first-in-jerusalem.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=First_Time_In_Jerusalem",
    //     "isVid": true,
    //     "vidId":"FvAWuLQEOJw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id": "First_Time_In_Jerusalem"
    // },
   
    
   
    
    
   
    // {
    //     "title": "تل أبيب بجانب البحر",
    //     // "sml_desc": "Cause life’s a beach in Tel Aviv ",
    //     "sml_desc": "",
    //     // "desc": "Get ready for some serious fun",
    //     "desc": "",
    //     "img": "Videos/a.jpg",
    //     "img_mob":"/Videos/video_mob/a.jpg",
    //     "side_img": "Videos/sidebar/a.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?postType=video&post=3",
    //     "css_class": "unic_video-post-4",
    //     // "vidId": "XDei1Zy_cu4",
    //     "ctg": "telaviv",
    //     "isVid": true,
    //     "id": "TelAviv_By_The_Sea"
    // },
   
    
    // {
    //    "title": "أطباق يجب تناولها في القدس",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "img_mob":"/PostCarousel/video_mob/must-eat-in-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Must_Eat_In_Jerusalem",
    //     "isVid": true,
    //     "vidId": "2CSCe2WC7Ns",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id": "Must_Eat_In_Jerusalem"
    // },
   
    
    // {
    //    "title": "بهاء الطبيعة",
    //     // "sml_desc": "THE DEAD SEA",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/DeadSea/natures-glory.jpg",
    //     "img_mob":"/PostCarousel/video_mob/natures-glory.jpg",
    //     "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Natures_Glory",
    //     "isVid": true,
    //     "vidId": "M627s8TdaB8",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "deadsea",
    //     "id": "Natures_Glory"
    // },
   
    {
        "title": "سارونا تل أبيب",
        "desc": "",
        // "desc": "A huge selection of attractions  <br/> in a stunningly renovated Templar colony",
        // "sml_desc": "A stunning urban oasis",
        "sml_desc": "",
        "img": "Videos/d.jpg",
        "img_mob":"/Videos/video_mob/d.jpg",
        "side_img": "Videos/sidebar/d.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=Sarona_TelAviv",
        "vidId": "MJ-gsGs1tqA",
        "ctg": "telaviv",
        "isVid": true,
        "id": "Sarona_TelAviv"
    },
    
   
    // {
    //     "title": "أهمّ المواقع في القدس",
    //     // "sml_desc": "Travel back thousands of years",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    //     "img_mob":"/PostCarousel/video_mob/main-sites-jer.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=9",
    //     "isVid": true,
    //     "vidId":"k4OwoEk5wMw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id":"Jerusalem_Main_Sites"
    // },

    // Hadar asked to hide this post on 2021-02-08
    // {
    //    "title" : "طعام الشوارع السريع في تل أبيب",
    //     // "sml_desc" : "Tel Aviv street food",
    //     "sml_desc" : "",
    //     // "desc" : "A true world-class foodie destination",
    //      "desc" : "",
    //     "img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    //     "img_mob":"/PostCarousel/video_mob/streetfood-telaviv.jpg",
    //     "side_img": "/PostCarousel/TelAviv/streetfood-telaviv.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Tel_Aviv_Street_Food",
    //     "isVid": true,
    //     "vidId":"JQD9JpMaw9g",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "telaviv",
    //     "id": "Tel_Aviv_Street_Food"
    // },
    //end Hadar asked to hide this post on 2021-02-08
  
    
    //  {
    //      "title":"إيلات تناديكم",
    //      "sml_desc":"",
    //      "desc":"",
    //      "img":"/PostCarousel/eilat-calling.jpg",
    //      "img_mob":"/PostCarousel/video_mob/eilat-calling.jpg",
    //      "side_img":"/PostCarousel/eilat-calling.jpg",
    //      "read_more":"READ MORE",
    //      "link": "/Posts/index.php?post=Eilat_Calling", 
    //      "css_class":"unic-post-eilat-calling",
    //      "isVid" : false,
    //     //  "vidId":"ZdnNT-GDJv4",
    //      // "isVid": false,
    //      "forVidPage": false,
    //      "ctg"   : 'eilat-negev',
    //       "id"    : 'Eilat_Calling'
    //     },
    
    
    // {
    //     "title": "التمتع بالشاطئ لأقصى حد",
    //     "sml_desc": "",
    //     // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "img_mob":"/PostCarousel/video_mob/ultimate-beaches.jpg",
    //     "side_img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=24",
    //     "css_class": "unic_video-post-1",
    //     // "vidId": "88OV6xU0vPI",
    //     "isVid": false,
    //     "id":"Ultimate_Beach_Fun",
    //     "ctg": "telaviv",
    //     "showOnHome": false,

    // },
    //Hadar asked to hide this post on 2021-02-01
    // {
    //     "title": "حديثة ونابضة بالحياة",
    //     // "sml_desc": "So much to see in Jerusalem’s",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/19.jpg",
    //     "img_mob":"/PostCarousel/video_mob/modern-vibrant.jpg",
    //     "side_img": "/PostCarousel/19.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Modern_And_Vibrant",
    //     "isVid": true,
    //     "vidId": "V0Acsw3Hf_M",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id": "Modern_And_Vibrant"
    // },
    //end Hadar asked to hide this post on 2021-02-01
    {
        "title": "روعة المدينة البيضاء",
        "sml_desc": "",
        "desc": "",
        "img": "thingsToDo/6.jpg",
        "side_img": "thingsToDo/sidebar/6.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=20",
        "css_class": "unic_video-post-1",
        "vidId": "88OV6xU0vPI",
        "isVid": true,
        // "isVid": false,
        "id": "White_City_Splendor",
        "showOnHome": false,
        "ctg": "telaviv"

    },
     {
       "title": "ظاهرة طبيعية",
        // "sml_desc": "THE DEAD SEA",
         "sml_desc": "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
        "img_mob":"/PostCarousel/video_mob/natural-phenomena.jpg",
        "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Natural_Phenomena",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "deadsea",
        "id": "Natural_Phenomena"
    },
    // {
    //    "title": "التمتع في القدس بعد حلول المساء",
    //     "sml_desc" : "",
    //     "desc" : "",
    //     "img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    //     "img_mob":"/PostCarousel/video_mob/after-dark-fun.jpg",
    //     "side_img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
    //     "isVid": true,
    //     "vidId":"FvAWuLQEOJw",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "ctg": "jerusalem",
    //     "id": "Jerusalem_After_Dark_Fun"
    // },
  
    // {
    //    "title" : "ثقافة بلا توقف",
    //     // "sml_desc": "Non Stop Culture",
    //     "sml_desc" : "",
    //     // "desc": "Tel Aviv’s fascinating cultural scene",
    //      "desc" : "",
    //     "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
    //     "img_mob":"/PostCarousel/video_mob/culture-telaviv.jpg",
    //     "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Non_Stop_Culture",
    //     "isVid": false,
    //     // "vidId":"MXtcTm_JXus",
    //     // "isVid": false,
    //     "ctg": "telaviv",
    //     "forVidPage": false,
    //     "id": "Non_Stop_Culture"
    // },
    // {
    //     "title": "ALL SENSORY MARKETS",
    //     "sml_desc": "",
    //     "img": "thingsToDo/8.jpg",
    //     "side_img": "thingsToDo/sidebar/8.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=20",
    //     "css_class": "unic_video-post-1",
    //     "vidId": "88OV6xU0vPI",
    //     "isVid": true,
    //     // "isVid": false,
    //     "id": "All_Sensory_Markets",
    //     "showOnHome": false,
    //     "ctg": "culinary"

    // },


    
    
   
    
    
    
    // {
    //     "title": "إثارة بلا توقف",
    //     // "sml_desc": "unforgettable Tel Aviv ",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    //     "img_mob":"/PostCarousel/video_mob/nonstop-excitement2.jpg",
    //     "side_img": "/PostCarousel/TelAviv/nonstop-excitement2.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=Nonstop_Excitement",
    //     "ctg": "telaviv",
    //     "isVid": true,
    //     "vidId": "88OV6xU0vPI",
    //     // "isVid": false,
    //     "forVidPage": true,
    //     "id": "Nonstop_Excitement"
    // },

    // Eilat Posts
        {
         "title":"إيلات",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat1.jpg",
         "img_mob":"/PostCarousel/video_mob/eilat1.jpg",
         "side_img":"/PostCarousel/eilat1.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=EILAT1", 
         "css_class":"unic-post-EILAT1",
         "isVid" : false,
        //  "vidId": "ZdnNT-GDJv4",
         // "isVid": false,
         "forVidPage": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'EILAT1'
        },
    //     {
    //     "title": "عاصمة الحفلات",
    //     // "sml_desc": "Epic Nights in the non stop city",
    //     "sml_desc": "",
    //     "desc": "",
    //     "img": "/PostCarousel/42.jpg",
    //     "img_mob":"/PostCarousel/video_mob/party-capital.jpg",
    //     "side_img": "/PostCarousel/42.jpg",
    //     "read_more": "READ MORE",
    //     "link": "/Posts/index.php?post=42",
    //     "isVid": false,
    //     // "vidId":"ogEN7aRT0SM",
    //     // "isVid": false,
    //     "forVidPage": false,
    //     "ctg": "telaviv",
    //     "id": "Party_Capital"
    // },
        // {
        //  "title":"أهلا بكم في إيلات",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/welcome-to-eilat.jpg",
        //  "img_mob":"/PostCarousel/video_mob/welcome-to-eilat.jpg",
        //  "side_img":"/PostCarousel/welcome-to-eilat.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Welcome_To_Eilat", 
        //  "css_class":"unic-post-welcome-to-eilat",
        // //  "isVid" : true,
        // //  "vidId":"ZdnNT-GDJv4",
        //  "isVid": false,
        //  "forVidPage": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Welcome_To_Eilat'
        // },
       
       
       
       
        
      
       
        // {
        //  "title":"النقب",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/negev.jpg",
        //  "img_mob":"/PostCarousel/video_mob/negev1.jpg",
        //  "side_img":"/PostCarousel/negev.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Negev1", 
        //  "css_class":"unic-post-negev",
        //  "isVid" : true,
        //  "vidId":"yXzhH92kREg",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Negev1'
        // },
       
        // {
        //  "title":"الشاطئ الأمثل في إيلات",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/eilat-ultimate-beachside.jpg",
        //  "img_mob":"/PostCarousel/video_mob/eilat-ultimate-beachside.jpg",
        //  "side_img":"/PostCarousel/eilat-ultimate-beachside.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Eilat_Ultimate_Beachside", 
        //  "css_class":"unic-post-eilat-ultimate-beachside",
        // //  "isVid" : true,
        // //  "vidId":"ZdnNT-GDJv4",
        //  "isVid": false,
        //  "forVidPage": false,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Eilat_Ultimate_Beachside'
        // },
       
        // {
        //  "title":"مسادا الأسطورية",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/epic-masada.jpg",
        //  "img_mob":"/PostCarousel/video_mob/epic-masada.jpg",
        //  "side_img":"/PostCarousel/epic-masada.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Epic_Masada", 
        //  "css_class":"unic-post-epic-masada",
        //  "isVid" : true,
        //  "vidId":"XxWa_MNm5x8",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Epic_Masada'
        // },
        {
        "title": "البحر الميت",
        // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/DeadSea/next-level-ar.jpg",
        "img_mob":"/PostCarousel/video_mob/next-level-ar.jpg",
        "side_img": "/PostCarousel/DeadSea/next-level-ar.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Next_Level_DS",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "deadsea",
        "id": "Next_Level_DS"
        },
       
        // {
        //  "title":"سحر النقب",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/negev-charms.jpg",
        //  "img_mob":"/PostCarousel/video_mob/negev-charms.jpg",
        //  "side_img":"/PostCarousel/negev-charms.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Negev_Charms", 
        //  "css_class":"unic-post-negev-charms",
        //  "isVid" : true,
        //  "vidId":"3UddwPEzDXo",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Negev_Charms'
        // },
        
       
        

        // {
        //     "title": "شواطئ رائعة",
        //     // "sml_desc": "Come chill by the sunny beaches",
        //     "sml_desc": "",
        //     "desc": "",
        //     "img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        //     "side_img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
        //     "read_more": "READ MORE",
        //     "link": "/Posts/index.php?post=14",
        //     "isVid": false,
        //     // "vidId":"XDei1Zy_cu4",
        //     // "isVid": false,
        //     "forVidPage": false,
        //     "isDouble": false,
        //     "ctg": "telaviv",
        //     //"id": 14
        //     "id":"Sensational_Beaches"
        // },
        //   {
        //  "title":"الموقع  وطريقة الوصول",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/location-and-approach.jpg",
        //  "img_mob":"/PostCarousel/video_mob/location-and-approach.jpg",
        //  "side_img":"/PostCarousel/location-and-approach.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=Location_And_Approach", 
        //  "css_class":"unic-post-location-and-approach",
        //  "isVid" : true,
        //  "vidId":"5AAqIhkq_tQ",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "ctg"   : 'eilat-negev',
        //   "id"    : 'Location_And_Approach'
        // },
        {
         "title":"كنوز \"تيمنع\"",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/timna-treasures.jpg",
         "img_mob":"/PostCarousel/video_mob/timna-treasures.jpg",
         "side_img":"/PostCarousel/timna-treasures.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Timna_Treasures", 
         "css_class":"unic-post-timna-treasures",
         "isVid" : true,
         "vidId":"i_4QKtXIeto",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Timna_Treasures'
        },
        
         
       
        {
         "title":"متعة المغامرة في الصحراء الإسرائيلية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "img_mob":"/PostCarousel/video_mob/action-fun-in-the-desert.jpg",
         "side_img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Action_Fun_In_The_Desert", 
         "css_class":"unic-post-action-fun-in-the-desert",
         "isVid" : true,
        "vidId":"yXzhH92kREg",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Action_Fun_In_The_Desert'
        },

        // Hadar asked to hide this post The_Sea_Of_Galilee on 2021-02-04
        // {
        //  "title":"(بحيرة الجليل) طبريا",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/sea-of-galilee.jpg",
        //  "img_mob":"/PostCarousel/video_mob/sea-of-galilee.jpg",
        //  "side_img":"/PostCarousel/sea-of-galilee.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=The_Sea_Of_Galilee", 
        //  "css_class":"unic-post-sea-of-galilee",
        //  "isVid" : true,
        //  "vidId":"haG-t3wwuMc",
        //  // "isVid": false,
        //  "forVidPage": true,
        //  "ctg"   : 'north',
        //   "id"    : 'The_Sea_Of_Galilee'
        // },
        // End Hadar asked to hide this post The_Sea_Of_Galilee on 2021-02-04
       
        
        
        
        
        
       
        
        
       


        // These three posts is for complite the 4 post in carousel in mobile for THINGS TO DO carousel
        {
         "title": "المنتجع الصحي الطبيعي: البحر الميت",
          "sml_desc" : "",
          // "sml_desc": "THE DEAD SEA",
          "desc" : "",
          "img": "/PostCarousel/DeadSea/natural-spa.jpg",
          "img_mob":"/PostCarousel/video_mob/natural-spa.jpg",
          "side_img": "/PostCarousel/DeadSea/natural-spa.jpg",
          "read_more": "READ MORE",
          "link": "/Posts/index.php?post=Natural_Spa",
          "isVid": true,
          "vidId": "M627s8TdaB8",
          // "isVid": false,
          "forVidPage": true,
          "isDouble": true,
          "ctg": "deadsea",
          "id": "Natural_Spa"
      },
      // {
      //      "title":"سحر النقب",
      //      "sml_desc":"",
      //      "desc":"",
      //      "img":"/PostCarousel/negev-charms.jpg",
      //      "img_mob":"/PostCarousel/video_mob/negev-charms.jpg",
      //      "side_img":"/PostCarousel/negev-charms.jpg",
      //      "read_more":"READ MORE",
      //      "link": "/Posts/index.php?post=Negev_Charms", 
      //      "css_class":"unic-post-negev-charms",
      //      "isVid" : true,
      //      "vidId":"3UddwPEzDXo",
      //      // "isVid": false,
      //      "forVidPage": true,
      //      "isDouble": true,
      //      "ctg"   : 'eilat-negev',
      //       "id"    : 'Negev_Charms'
      //     },
          
          // These three posts is for complite the 4 post in carousel in mobile for THINGS TO DO carousel
        
]

export const TouristInfoPosts = [


        {
         "title":"الأجهزة الكهربائية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/electrical-appliances.jpg",
         "side_img":"/PostCarousel/electrical-appliances.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-electrical-appliances",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Electrical_Appliances'
        },
        {
         "title":"حالة الطقس",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/weather.jpg",
         "side_img":"/PostCarousel/weather.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-weather",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Weather'
        },
        {
         "title":"أسئلة شائعة بخصوص",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/faq.jpg",
         "side_img":"/PostCarousel/faq.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-faq",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Frequently_Asked_Questions'
        },
        {
         "title":"معلومات حول جوازات السفر والتأشيرات",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/Passports-visa.jpg",
         "side_img":"/PostCarousel/Passports-visa.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-Passports-visa",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Passports_Visa'
        },
        {
         "title":"العملة الإسرائيلية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/israeli-currency.jpg",
         "side_img":"/PostCarousel/israeli-currency.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-israeli-currency",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Israeli_Currency'
        },
        {
         "title":"What To Pack",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/what-to-pack.jpg",
         "side_img":"/PostCarousel/what-to-pack.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-what-to-pack",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'What_To_Pack'
        },
        // This post had moved to the Passport post/ ASked by HADAR 18.05.2020
        //  {
        //  "title":"Immigration Customs",
        //  "sml_desc":"",
        //  "desc":"",
        //  "img":"/PostCarousel/immigration-customs.jpg",
        //  "side_img":"/PostCarousel/immigration-customs.jpg",
        //  "read_more":"READ MORE",
        //  "link": "/Posts/index.php?post=20", 
        //  "css_class":"unic-post-immigration-customs",
        //  "isVid" : false,
        //  "ctg"   : 'TouristInfo',
        //   "id"    : 'Immigration_Customs'
        // },
        // END This post had moved to the Passport post/ ASked by HADAR 18.05.2020
        
        
        {
         "title":"وسائل النقل والمواصلات",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/transportation.jpg",
         "side_img":"/PostCarousel/transportation.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-transportation",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Transportation'
        },
        
       
        
        
        
        {
         "title":"وجهة للجميع",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg",
         "side_img":"/PostCarousel/PlanYourTrip/destination-for-all.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=20", 
         "css_class":"unic-post-Passports-visa",
         "isVid" : false,
         "ctg"   : 'TouristInfo',
          "id"    : 'Destination_For_All'
        },


]






// These posts for THINGS TO DO Page
export const thingsToDoPosts = [

    {
       "title": "متع الميناء",
        // "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports",
        "sml_desc" : "",
        // "desc": "Tel Aviv’s fascinating cultural scene",
         "desc" : "",
        "img": "/PostCarousel/TelAviv/jaffa-port.jpg",
        "side_img": "/PostCarousel/TelAviv/jaffa-port.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Port_Pleasures",
        "isVid": false,
        "isDouble": false,
        "ctg": "telaviv",
        "id": "Port_Pleasures"
    },

    {
        "title": "متع التسوق",
        // "sml_desc": "From culture to souvenirs",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/5.jpg",
        "side_img": "/PostCarousel/5.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Shopping_Delights",
        "ctg": "jerusalem",
        // "isVid": false,
        "isVid": true,
        "isDouble": false,
        "vidId":"V0Acsw3Hf_M",
        "forVidPage": true,
        "id": "Shopping_Delights"
    },

    {
       "title": "ظاهرة طبيعية",
        // "sml_desc": "THE DEAD SEA",
         "sml_desc": "",
        "desc" : "",
        "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
        "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Natural_Phenomena",
        "isVid": true,
        "vidId": "M627s8TdaB8",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": false,
        "ctg": "deadsea",
        "id": "Natural_Phenomena"
    },

    

    {
        "title": "التجوال بالدراجة الهوائية في تل أبيب",
        // "desc": "Get on your bicycle -<br> explore the city in style",
        "sml_desc": "",
        "desc": "",
        "img": "PostCarousel/39.jpg",
        "side_img": "PostCarousel/39.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=38",
        "ctg": "telaviv",
        "isVid": true,
        "isDouble": false,
        "vidId": "5nqL-oIC0GA",
        // "isVid": false,
        "forVidPage": true,
        "id": "Cycle_TelAviv"
    },

    {
        "title": "حياة ليلية مجنونة",
        // "sml_desc": " Book your trip to Tel Aviv!",
        "sml_desc": "",
        // "desc": "",
        "desc": "",
        "img": "Videos/crazy-night.jpg",
        "img_mob":"/Videos/video_mob/crazy-night.jpg",
        "side_img": "Videos/sidebar/crazy-night.jpg",
        "read_more": "READ MORE",
        "vidId": "",
        "ctg": "telaviv",
        "isDouble": false,
        "isVid": false,
        "id": "Amazing_Nightlife"
    },

    {
         "title":"متعة المغامرة في الصحراء الإسرائيلية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "side_img":"/PostCarousel/action-fun-in-the-desert.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Action_Fun_In_The_Desert", 
         "css_class":"unic-post-action-fun-in-the-desert",
         "isVid" : true,
         "isDouble": false,
         "vidId":"yXzhH92kREg",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'Action_Fun_In_The_Desert'
    },

    {
        "title": "تل أبيب بجانب البحر",
        // "sml_desc": "Cause life’s a beach in Tel Aviv ",
        "sml_desc": "",
        // "desc": "Get ready for some serious fun",
        "desc": "",
        "img": "Videos/a.jpg",
        "img_mob":"/Videos/video_mob/a.jpg",
        "side_img": "Videos/sidebar/a.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=3",
        "css_class": "unic_video-post-4",
        // "vidId": "XDei1Zy_cu4",
        "ctg": "telaviv",
        "isVid": false,
        "isDouble": false,
        "id": "TelAviv_By_The_Sea"
    },

    {
        "title": "مذاق من القدس",
        // "sml_desc": "Must eat dishes to try when visiting the magical city",
        "desc": "",
        "sml_desc": "",
        "img": "/PostCarousel/37.jpg",
         "img_mob":"/PostCarousel/video_mob/37.jpg",
        "side_img": "/PostCarousel/37.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=38",
        "ctg": "culinary",
        "vidId": "2CSCe2WC7Ns",
        "isVid": true,
        "isDouble": false,
        "id": "A_Taste_Of_Jerusalem"
    },

    //////////////////////////

    {
        "title": "سياحة الهايتك",
        // "sml_desc": "Tech Tourism",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/General/techtourism.jpg",
        "side_img": "/PostCarousel/General/techtourism.jpg",
        "read_more": "READ MORE",
        "isVid": false,
        "forVidPage": false,
        "isDouble": false,
        "ctg": "general",
        "id": "Tech_tourism"
    },

    {
        "title": "مدينتان رائعتان",
        // "sml_desc": "One magical unforgettable getaway to the sun",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/General/tw-awesome-cities.jpg",
        "side_img": "/PostCarousel/General/tw-awesome-cities.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=42",
        "isVid": false,
        // "vidId": "b0QexDxEklA",
        "forVidPage": false,
        "isDouble": false,
        "ctg": "general",
        "id": "2_AWESOME_CITIES"
    },

    {
         "title":"المبيت في النقب",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/stay-in-the-negev.jpg",
         "side_img":"/PostCarousel/stay-in-the-negev.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Stay_In_The_Negev", 
         "css_class":"unic-post-stay-in-the-negev",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Stay_In_The_Negev'
    },

    {
        "title": "استمتعوا.. انغمسوا!",
        // "sml_desc": "Enjoy and Indulge",
        "sml_desc": "",
        // "desc": "Tel Aviv - The ultimate luxury destination",
        "desc": "",
        "img": "/PostCarousel/36.jpg",
        "side_img": "/PostCarousel/36.jpg",
            "read_more": "READ MORE",
        "link": "/Posts/index.php?post=37",
        "ctg": "telaviv",
        "isDouble": false,
        "isVid": false,
        "id": 37
    },

    {
         "title":"الإثارة  في إيلات",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/action-packed-eilat.jpg",
         "side_img":"/PostCarousel/action-packed-eilat.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Action_Packed_Eilat", 
         "css_class":"unic-post-action-packed-eilat",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Action_Packed_Eilat'
    },

    {
       "title" : "الإفطار في إسرائيل",
        // "sml_desc" : "A LEGEND IN ITS OWN MEALTIME",
        "sml_desc" : "",
        // "desc" : "",
         "desc" : "",
        "img": "/PostCarousel/Culinary/breackfast-in-israel.jpg",
        "img_mob":"/PostCarousel/video_mob/breackfast-in-israel.jpg",
        "side_img": "/PostCarousel/Culinary/breackfast-in-israel.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Breakfast-In-Israel",
        "isVid": true,
        "isDouble": false,
        "vidId":"JJ7PhOw1p5E",
        // "isVid": false,
        "forVidPage": true,
        "ctg": "culinary",
        "id": "Breakfast-In-Israel"
    },

    {
        "title": "متحف \"ياد فا شيم\" الذي لا يُنسى",
        "sml_desc": "",
        "img": "thingsToDo/10.jpg",
        "side_img": "thingsToDo/sidebar/10.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=20",
        "css_class": "unic_video-post-1",
        "vidId": "88OV6xU0vPI",
        "isVid": false,
        "isDouble": false,
        id: 31,
        "showOnHome": false,
        "ctg": "jerusalem"

    },

    {
         "title":"ذكرى تدوم مدى الحياة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "side_img":"/PostCarousel/eilat-doolphin-reef.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Eilat_Doolphin_Reef", 
         "css_class":"unic-post-eilat-doolphin-reef",
         "isVid" : true,
         "vidId":"3Cvz8GoxNzA",
         // "isVid": false,
         "forVidPage": true,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'Eilat_Doolphin_Reef'
    },

    {
        "title": "جورميه تل أبيب",
        // "sml_desc": "The perfect place\n to treat yourself",
        "sml_desc": "",
        // "desc": "Tel Aviv's huge variety of amazing",
        "desc": "",
        "img": "Videos/gourmet-telaviv.jpg",
        "img_mob":"/Videos/video_mob/gourmet-telaviv.jpg",
        "side_img": "Videos/sidebar/gourmet-telaviv.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=33",
        "vidId": "jfyHxk8ZRrI",
        "ctg": "culinary",
        "isVid": true,
        "isDouble": false,
        "id": "Gourmet_TelAviv"
    },

    {
       "title": "الفنّ في القدس",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
        "side_img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jerusalem_Arts",
        "isVid": false,
        "isDouble": false,
        "ctg": "jerusalem",
        "id": "Jerusalem_Arts"
    },

    {
         "title":"طريق البخور",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-incense-route.jpg",
         "side_img":"/PostCarousel/the-incense-route.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Incense_Route", 
         "css_class":"unic-post-the-incense-route",
         "isVid" : true,
         "isDouble": false,
         "vidId":"5AAqIhkq_tQ",
         "forVidPage": true,
         "ctg"   : 'eilat-negev',
          "id"    : 'The_Incense_Route'
    },

    {
        "title": "المشهد الخُضري في تل أبيب",
        // "sml_desc": "Voted # 1 Vegan destination in the world  ",
        // "desc": "Enjoy the huge choice of vegan",
        "sml_desc": "",
        "desc": "",
        "img": "Videos/h.jpg",
        "img_mob":"/Videos/video_mob/h.jpg",
        "side_img": "Videos/sidebar/h.jpg",
        "vidId": "9l04RfZ95J0",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=6",
        "ctg": "culinary",
        "isVid": true,
        "isDouble": false,
        "id": "Vegan_Friendly_TelAviv"
    },

    {
        "title": "جميع الأسواق المبهرة",
        "sml_desc": "",
        "desc": "",
        "img": "thingsToDo/8.jpg",
        "side_img": "thingsToDo/sidebar/8.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=20",
        "css_class": "unic_video-post-1",
        "vidId": "88OV6xU0vPI",
        "isVid": false,
        "isDouble": false,
        "id": "All_Sensory_Markets",
        "showOnHome": false,
        "ctg": "jerusalem"

    },

    {
         "title":"إثارة في الجليل",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/galilee-action.jpg",
         "side_img":"/PostCarousel/galilee-action.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Galilee_Action", 
         "css_class":"unic-post-galilee-action",
         "isVid" : true,
         "isDouble": false,
         "vidId":"5Ep3GgxELag",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'Galilee_Action'
    },

    {
         "title":"الحداق الوطنية",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/national-parks.jpg",
         "side_img":"/PostCarousel/national-parks.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=National_Parks", 
         "css_class":"unic-post-national-parks",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'general',
          "id"    : 'National_Parks'
    },

    {
        // "title": "A Foodie’s Paradise‘",
        "title" : "مذاق شهي، بكل بساطة",
        // "sml_desc": "Check out Tel Aviv’s \n awesome culinary Scene",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/99.jpg",
        "img_mob":"/PostCarousel/video_mob/99.jpg",
        "side_img": "/PostCarousel/99.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=21",
        "ctg": "culinarytelaviv",
        "vidId": "JQD9JpMaw9g",
        "isVid": true,
        "isDouble": false,
        "id": "Simply_Delicious"
    },
     
     // Hadar asked to hide the video inside this post on 2021-02-04
    {
        "title": "أمور يجب عليكم تجربتها في القدس",
        // "sml_desc": "5 things to do in the stunning city",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/18.jpg",
        "side_img": "/PostCarousel/18.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Jerusalem_Musts",
        "isVid": false,
        "isDouble": false,
        "vidId": "FvAWuLQEOJw",
        "forVidPage": true,
        "ctg": "jerusalem",
        "id": "Jerusalem_Musts"
    },
    // End Hadar asked to hide the video inside this post on 2021-02-04
    
    {
       "title" : "ثقافة بلا توقف",
        // "sml_desc": "Non Stop Culture",
        "sml_desc" : "",
        // "desc": "Tel Aviv’s fascinating cultural scene",
         "desc" : "",
        "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
        "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Non_Stop_Culture",
        "isVid": false,
        // "vidId":"MXtcTm_JXus",
        "ctg": "telaviv",
        "forVidPage": false,
        "isDouble": false,
        "id": "Non_Stop_Culture"
    },

    {
         "title":"مسار الرحلات الوطني في إسرائيل",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/the-israel-national-trail.jpg",
         "side_img":"/PostCarousel/the-israel-national-trail.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Israel_National_Trail", 
         "css_class":"unic-post-the-israel-national-trail",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'eilat-negev',
          "id"    : 'The_Israel_National_Trail'
    },

    {
         "title":"مرصد الطيور في بحيرة الحولة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "side_img":"/PostCarousel/birdtastic-hula-lake.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=Birdtastic_Hula_Lake", 
         "css_class":"unic-post-birdtastic-hula-lake",
         "isVid" : true,
         "vidId":"ImobrsxsKl8",
         // "isVid": false,
         "forVidPage": true,
         "isDouble": false,
         "ctg"   : 'north',
          "id"    : 'Birdtastic_Hula_Lake'
    },

    {
        "title": "القدس كما لم تروها من قبل",
        // "sml_desc": "Modern luxuries for the pampered traveler",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/Jerusalem/45.jpg",
        "side_img": "/PostCarousel/Jerusalem/45.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=45",
        "isVid": false,
        "isDouble": false,
        "ctg": "jerusalem",
        "id": 45
    },

    {
         "title":"حدائق البهائيين المذهلة",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/bahai-gardens.jpg",
         "side_img":"/PostCarousel/bahai-gardens.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Bahai_Gardens", 
         "css_class":"unic-post-bahai-gardens",
         "isVid" : true,
         "isDouble": false,
         "vidId":"JV_AmfRULOo",
         // "isVid": false,
         "forVidPage": true,
         "ctg"   : 'north',
          "id"    : 'The_Bahai_Gardens'
    },

    {
        "title": "ضيافة فاخرة",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
        "side_img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Boutique_Hospitality",
        "isVid": false,
        "ctg": "telaviv",
        "isDouble": false,
        "id": "Boutique_Hospitality"
    },

    {
       "title": "جادة مأمن الله",
        "sml_desc" : "",
        "desc" : "",
        "img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "side_img": "/PostCarousel/Jerusalem/mamila-avenue.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Mamilla_Avenue",
        "isVid": true,
        "vidId": "V0Acsw3Hf_M",
        // "isVid": false,
        "forVidPage": true,
        "isDouble": false,
        "ctg": "jerusalem",
        "id": "Mamilla_Avenue"
    },

    {
        "title": "روعة المدينة البيضاء",
        "sml_desc": "",
        "desc": "",
        "img": "thingsToDo/6.jpg",
        "side_img": "thingsToDo/sidebar/6.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=20",
        "css_class": "unic_video-post-1",
        "vidId": "88OV6xU0vPI",
        "isVid": false,
        "isDouble": false,
        // "isVid": false,
        "id": "White_City_Splendor",
        "showOnHome": false,
        "ctg": "telaviv"

    },

    {
        "title": "عجائب حائط المبكى",
        "sml_desc": "",
        "img": "thingsToDo/4.jpg",
        "side_img": "thingsToDo/sidebar/4.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Western_Wall_Wonders",
        "css_class": "unic_video-post-Western_Wall_Wonders",
        "vidId": "88OV6xU0vPI",
        "isVid": false,
        "isDouble": false,
        "id": "Western_Wall_Wonders",
        "ctg": "jerusalem",
        "showOnHome": false,

    },

    {
        "title": "أسواق بلا توقّف",
        "sml_desc": "",
        "desc": "",
        "img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
        "side_img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?post=Non_Stop_Markets",
        "isVid": false,
        "ctg": "telaviv",
        "isDouble": false,
        "id": "Non_Stop_Markets"
    },

    {
         "title":"تجربة الكيبوتس التي لا تضاهى",
         "sml_desc":"",
         "desc":"",
         "img":"/PostCarousel/kibbutz-experience.jpg",
         "side_img":"/PostCarousel/kibbutz-experience.jpg",
         "read_more":"READ MORE",
         "link": "/Posts/index.php?post=The_Kibbutz_Experience", 
         "css_class":"unic-post-kibbutz-experience",
         "isVid" : false,
         "isDouble": false,
         "ctg"   : 'north',
          "id"    : 'The_Kibbutz_Experience'
    },

    {
        "title": "قهوة في تل أبيب",
        // "sml_desc": "Tel Aviv over a fresh coffee",
        "sml_desc": "",
        // "desc": "Coffee shop culture is fundamental",
        "desc":" ",
        "img": "Videos/coffee.jpg",
         "img_mob":"/Videos/video_mob/coffee.jpg",
        "side_img": "Videos/sidebar/coffee.jpg",
        "read_more": "READ MORE",
        "link": "/Posts/index.php?postType=video&post=16",
        "vidId": "rVr0gqFC364",
        "ctg": "culinarytelaviv",
        "isVid": true,
        "isDouble": false,
        "id": "Coffee_In_TelAviv"
    },

    
    // End THINGS TO DO POSTS
]

export const Reminders = [

       // Tel Aviv
      {
        "quote": "One of the world's 25 best cities for foodies",
        "site": "Business Insider",
        "img": "/References/1.jpg",
        "ctg": "Tel Aviv",

       
      },

      // Jerusalem
      {
        "quote": "TripAdvisor Traveler's Choice Award 2015",
        "site": "TripAdvisor",
        "img": "/References/9.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the world's leading party cities",
        "site": "Telegraph",
        "img": "/References/2.jpg",
        "ctg": "Tel Aviv",
       
      },
      

      {
        "quote": "One of the cities with most beautiful people",
        "site": "Conde Nast",
        "img": "/References/3.jpg",
        "ctg": "Tel Aviv",
       
      },

      {
        "quote": "One of the 20 must visit destinations in the world  TNS",
        "site": "The National Student",
        "img": "/References/10.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the best beach party spots on the planet",
        "site": "USA Today",
        "img": "/References/4.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "One of the world's top 10 beach cities",
        "site": "National Geographic",
        "img": "/References/5.jpg",
        "ctg": "Tel Aviv",
       
      },

      {
        "quote": "3rd Of 6 Top world’s holiest sites",
        "site": "National Geographic",
        "img": "/References/11.jpg",
        "ctg": "Jerusalem",
       
      },

      {
        "quote": "One of the world's top ten cities",
        "site": "Lonely Planet",
        "img": "/References/6.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "One of the world's top ten hedonistic city breaks ",
        "site": "Lonely Planet",
        "img": "/References/7.jpg",
        "ctg": "Tel Aviv",
       
      },
      {
        "quote": "I just thought it was magical… It instantly turned into my favorite trip.",
        "site": "TripAdvisor",
        "img": "/References/12.jpg",
        "ctg": "Jerusalem",
        "job" : "CEO, Stephen Kaufer about Jerusalem" ,
        "cssClass" : "make-it-smller"
      },

      {
        "quote": "The World’s New Dining Hotspot",
        "site": "Bloomberg.com",
        "img": "/References/8.jpg",
        "ctg": "Tel Aviv",
       
      },

      

]







// WEBPACK FOOTER //
// ./src/Data/Data.js